'use strict';

const _ = require('lodash');
const angular = require('angular');
import * as Blockly from 'blockly';
window['Blockly1'] = Blockly;

import '../../assets/scripts/vendor/MinMax_DateValue';
import '../../assets/scripts/vendor/dynamic-dropdown-mutator';
import '../../assets/scripts/vendor/multi-dropdown-option';

const PropertyDetail = {
  "Label": [["Hidden", "hidden"], ["Font Family", "font-family"], ["Font Size", "font-size"], ["Font Weight", "font-weight"], ["Font Style", "font-style"], ["Text Decoration", "text-decoration"], ["Text Align", "text-align"], ["Color", "color"], ["Background Color", "background-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Text", "text"]],
  "Button": [["Hidden", "hidden"], ["Font Family", "font-family"], ["Font Size", "font-size"], ["Font Weight", "font-weight"], ["Font Style", "font-style"], ["Text Decoration", "text-decoration"], ["Text Align", "text-align"], ["Color", "color"], ["Background Color", "background-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Read-only", "readOnly"], ['Text', 'text'], ["Width", "width"], ["Height", "height"]],
  "DisplayField": [["Background Color", "background-color"], ["Hidden", "hidden"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Label", "label"]],
  "Textbox": [["Background Color", "background-color"], ["Required", "required"], ["Placeholder", "placeHolder"], ["Read-only", "readOnly"], ["Hidden", "hidden"], ["Char-Limit", "charLimit"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Format", "validate"], ["Label", "label"]],
  "Textarea": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Placeholder", "placeHolder"], ["Read-only", "readOnly"], ["Char-Limit", "charLimit"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Format", "validate"], ["Size", "size"], ["Label", "label"]],
  "RichTextArea": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Label", "label"]],
  "Dropdown": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Multi Select", "multiSelect"], ["Read-only", "readOnly"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Options", "options"], ["Label", "label"]],
  "Checkbox": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Options", "options"], ["Label", "label"]],
  "Radio": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Options", "options"], ["Label", "label"]],
  "Datepicker": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Display Format", "displayFormat"],["Time", "time"],["Time Format", "hourFormat"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Label", "label"]],
  "Map": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Label", "label"]],
  "Image": [["Hidden", "hidden"], ["Font Family", "font-family"], ["Font Size", "font-size"], ["Font Weight", "font-weight"], ["Font Style", "font-style"], ["Text Decoration", "text-decoration"], ["Text Align", "text-align"], ["Color", "color"], ["Background Color", "background-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Width", "width"], ["Height", "height"], ["URL", "url"]],
  "Signature": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Font Family", "font-family"], ["Font Size", "font-size"], ["Font Weight", "font-weight"], ["Font Style", "font-style"], ["Text Decoration", "text-decoration"], ["Text Align", "text-align"], ["Color", "color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Label", "label"]],
  "Attachment": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Font Family", "font-family"], ["Font Size", "font-size"], ["Font Weight", "font-weight"], ["Font Style", "font-style"], ["Text Decoration", "text-decoration"], ["Text Align", "text-align"], ["Color", "color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Label", "label"]],
  "Line": [["Background Color", "background-color"], ["Border Color", "border-top-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"]],
  "Layout": [["Border Width", "layoutBorderWidth"], ["Background Color", "background-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Hidden", "hidden"]],
  "Table": [["Background Color", "background-color"], ["Border Width", "borderWidth"], ["Border Color", "borderColor"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Hidden", "hidden"]],
  "RepeatingTable": [["Background Color", "background-color"], ["Border Width", "reapeatingBorderWidth"], ["Border Color", "reapeatingBorderColor"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Hidden", "hidden"], ["Show Insert Button", "show_insert_button"], ["Show Remove Button", "show_remove_button"], ["Even Row Background Color", "backgroundcoloreven"], ["Odd Row Background Color", "backgroundcolorodd"]],
  "ToggleButton": [["Background Color", "background-color"], ["Read-only", "readOnly"], ["Hidden", "hidden"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Label", "label"], ["Background Color On", "background-color-on"],["Background Color Off", "background-color-off"], ["Label Off", "label-off"],["Label On", "label-on"]],
  "Hyperlink": [["Background Color", "background-color"], ["Hidden", "hidden"],  ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Label", "label"], ["Display Label", "displayLabel"]],
  "MultiDropdown": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Options", "options"], ["Label", "label"]],
  "Timepicker": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Time Format", "hourFormat"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Label", "label"]],  
  "Rating": [["Background Color", "background-color"], ["Required", "required"], ["Placeholder", "placeHolder"], ["Read-only", "readOnly"], ["Hidden", "hidden"], ["Char-Limit", "charLimit"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Format", "validate"], ["Label", "label"]],
  "InlineAssocFiles": [["Hidden", "hidden"],["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"],   ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Read-only", "readOnly"], ['Text', 'text']],
  "InlineAssocApps": [["Hidden", "hidden"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"],  ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"],["Read-only", "readOnly"], ['Text', 'text']],
  "ViewAssociations": [["Hidden", "hidden"],["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"],   ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"]],
}

const PropertyType = {
  "value" : "STRING",
  "text" : "STRING",
  "label" : "STRING",
  "placeHolder" : "STRING",
  "tooltip" : "STRING",
  "options": "STRING",
  "hidden" : "BOOLEAN",
  "required" : "BOOLEAN",
  "readOnly" : "BOOLEAN",
  "multiSelect" : "BOOLEAN",
  "show_insert_button": 'BOOLEAN',
  "show_remove_button": 'BOOLEAN',
  "time":"BOOLEAN",
  "font-size" : "NUMBER",
  "label-font-size" : "NUMBER",
  "control-font-size" : "NUMBER",
  "padding-top" : "NUMBER",
  "padding-bottom" : "NUMBER",
  "padding-left" : "NUMBER",
  "padding-right" : "NUMBER",
  "width" : "NUMBER",
  "height" : "NUMBER",
  "borderWidth" : "NUMBER",
  "reapeatingBorderWidth" : "NUMBER",
  "charLimit" : "NUMBER",
  "size" : "NUMBER",
  "layoutColumns": "LAYOUT_COLUMNS_DROPDOWN",
  "layoutBorderWidth": "BORDER_WIDTH_DROPDOWN",
  "font-family" : "FONT_FAMILY_DROPDOWN",
  "label-font-family" : "FONT_FAMILY_DROPDOWN",
  "control-font-family" : "FONT_FAMILY_DROPDOWN",
  "font-weight" : "FONT_WEIGHT_DROPDOWN",
  "label-font-weight" : "FONT_WEIGHT_DROPDOWN",
  "control-font-weight" : "FONT_WEIGHT_DROPDOWN",
  "font-style" : "FONT_STYLE_DROPDOWN",
  "label-font-style" : "FONT_STYLE_DROPDOWN",
  "control-font-style" : "FONT_STYLE_DROPDOWN",
  "text-decoration" : "TEXT_DECORATION_DROPDOWN",
  "label-text-decoration" : "TEXT_DECORATION_DROPDOWN",
  "control-text-decoration" : "TEXT_DECORATION_DROPDOWN",
  "text-align" : "TEXT_ALIGN_DROPDOWN",
  "label-text-align" : "TEXT_ALIGN_DROPDOWN",
  "control-text-align" : "TEXT_ALIGN_DROPDOWN",
  "validate" : "VALIDATE_DROPDOWN",
  "displayFormat" : "DATE_FORMAT_DROPDOWN",
  "hourFormat" : "TIME_FORMAT_DROPDOWN",
  "color" : "COLOR_PICKER", 
  "background-color" : "COLOR_PICKER",
  "label-color" : "COLOR_PICKER",
  "control-color" : "COLOR_PICKER",
  "border-top-color" : "COLOR_PICKER",
  "borderColor" : "COLOR_PICKER",
  "reapeatingBorderColor" : "COLOR_PICKER",
  "background-color-on" : "COLOR_PICKER",
  "background-color-off" : "COLOR_PICKER",
  "displayLabel": 'STRING',
  "url":"STRING",
  "backgroundcoloreven": "COLOR_PICKER",
  "backgroundcolorodd": "COLOR_PICKER"
}

const PropertyTypeDropdown = {
  "FONT_FAMILY_DROPDOWN": [['Arial', 'Arial'], ['Helvetica', 'Helvetica'], ['Times New Roman', 'Times New Roman'], ['Times', 'Times'], ['Courier New', 'Courier New'], ['Courier', 'Courier'], ['Verdana', 'Verdana'], ['Georgia', 'Georgia'], ['Palatino Linotype', 'Palatino Linotype'], ['Garamond', 'Garamond'], ['Bookman Old Style', 'Bookman Old Style'], ['Comic Sans MS', 'Comic Sans MS'], ['Trebuchet MS', 'Trebuchet MS'], ['Arial Black', 'Arial Black'], ['Impact', 'Impact'], ['Calibri', 'Calibri'], ['Century Gothic', 'Century Gothic'], ['Sans Serif', 'Sans Serif'], ['Sofia Pro Regular', 'Sofia Pro Regular'], ['Sofia Pro Semi Bold', 'Sofia Pro Semi Bold']],
  "FONT_WEIGHT_DROPDOWN": [['Normal', ''], ['Bold', 'bold']],
  "FONT_STYLE_DROPDOWN": [['Normal', ''], ['Italic', 'italic']],
  "TEXT_DECORATION_DROPDOWN":[['Normal', ''], ['Underline', 'underline']],
  "TEXT_ALIGN_DROPDOWN": [['Left', 'left'], ['Right', 'right'], ['Center', 'center']],
  "VALIDATE_DROPDOWN": [['None', ''], ['Integer', 'Integer'], ['Decimal', 'Decimal'], ['Letters and Numbers', 'Alphanumeric'], ['Letters', 'Letters'], ['Email', 'Email']],
  "DATE_FORMAT_DROPDOWN": [['Default', 'default'], ['dd-mmm-yyyy', 'DD-MMM-YYYY'], ['dd-mm-yyyy', 'DD-MM-YYYY'], ['dd-mm-yy', 'DD-MM-YY'], ['mm-dd-yyyy', 'MM-DD-YYYY'], ['mm-dd-yy', 'MM-DD-YY'], ['dd/mm/yy', 'DD/MM/YY'], ['dd/mm/yyyy', 'DD/MM/YYYY']],
  "TIME_FORMAT_DROPDOWN":[['12Hrs', 'true'],['24Hrs','false']],
  "BORDER_WIDTH_DROPDOWN": [["0", "0px solid #ccc"], ["1", "1px solid #ccc"], ["2", "2px solid #ccc"], ["3", "3px solid #ccc"], ["4", "4px solid #ccc"], ["5", "5px solid #ccc"], ["6", "6px solid #ccc"], ["7", "7px solid #ccc"] ,["8", "8px solid #ccc"], ["9", "9px solid #ccc"], ["10", "10px solid #ccc"]],
  "LAYOUT_COLUMNS_DROPDOWN": [["1", "col-md-12/1"], ["2", "col-md-6/2"], ["3", "col-md-4/3"], ["4", "col-md-3/4"], ["5", "col-md-5/5"], ["6", "col-md-2/6"], ["7", "col-md-7/7"], ["8", "col-md-8/8"], ["9", "col-md-9/9"], ["10", "col-md-10/10"], ["11", "col-md-11/11"], ["12", "col-md-1/12"]]
}

const ExcludedSystemFields = ['DS_PRINTEDBY', 'DS_PRINTEDON'];
const DateSystemFields = ['DS_CLOSEDUEDATE', 'DS_DATEOFISSUE', 'DS_MSGDATE'];
const BooleanSystemFields = ['DS_ATTACHMENTS_ORI', 'DS_DOC_ASSOCIATIONS_ORI', 'DS_FORM_ASSOCIATIONS_ORI'];

export const ControlBlocklyBlocks = function (options) {
  const newOption = options;

  let customFields = options.fieldNames;
  let dataFieldNames = options.dataFieldNames;
  let systemSingleValue = options.systemSingleValue;
  let apiNames = options.apiNames;
  let responseDataOptions = [['Please select', '']];
  let ControlNameOptions = [['Select Control Name...', '']];
  let RepeatingTableControlNameOptions = [['Select Control Name...', '']];
  let sourceFields = [['Select Source Field', ''], ['Form ID', 'fixed_DS_FORMID']];
  let destinationFields = [['Select Target Field', '']];
  let projectsLists = options.projects;
  let currentProject = options.projectName;
  let currentProjectID = options.projectId;
  let viewNames = options.viewNames;
  let ViewNamesList =  [['Select View Name...', '']];
  let sortSourceFields = [];
  let sortCutomFields = _.sortBy(customFields, function(field) {
    return field.key.toLowerCase();
  });
  sortCutomFields.forEach(field => {
    ControlNameOptions.push([field.key, field.key]);

    if(field.type == "RepeatingTable") {
      RepeatingTableControlNameOptions.push([field.key, field.key]);
    }
  });
  viewNames.forEach(field => {
    ViewNamesList.push([field.name, field.value]);
  });
  
  let DateControlNameOptions = [['Select Control Name...', '']];
  let DateTimeControlOptions = [['Select Control Name...', '']];
  let DateTimeFormatOptions = [['Select Time Format...', ''], ['HH:MM','HH:MM'], ['HH','HH']];
  let ControlDataFieldNameOptions = [['Select Control Name...', '']];
  let APINameOptions = [['Select API Name...', '']];
  if(apiNames && apiNames.length > 0) {
    apiNames.forEach(field => {
      APINameOptions.push([field.name, field.name]);
    });
  }
  let sortCutomDataFields = _.sortBy(dataFieldNames, function (field) {
    return field.key.toLowerCase();
  });
  
  let AutoNumberControlNameOptions = [['Select Control Name...', '']];
  sortCutomDataFields.forEach(field => {
    ControlDataFieldNameOptions.push([field.key, field.key]);

    if(field.type == "Datepicker") {
      field.isTimeEnabled && DateTimeControlOptions.push([field.key, field.key])
      DateControlNameOptions.push([field.key, field.key]);
    }
    if(field.type == "Textbox" && field.parent != 'repeating-table') {
      AutoNumberControlNameOptions.push([field.key, field.key]);
    }
    
    if (field.parent == 'repeating-table') {
      sortSourceFields.push([field.key + ' ( ' + field.parentFieldName + ' ) ', field.key])
    } else {
      sortSourceFields.push([field.key, field.key])
    }
  });
  
  sortSourceFields = _.sortBy(sortSourceFields, [sourceField => sourceField[0].toLowerCase()], ['asce']);
  sortSourceFields.map((array) => sourceFields.push(array));

  let functionalityOptions = [["Select Type....", ""], ["Auto Insert Row", "insertRow"], ["Auto Delete Row", "deleteRow"], ["Make Read Only", "readOnly"], ["Show Row", "showRow"]];
  let AutoHasIndexOptions = [['#', 'randomRow']];
  let AutoHasIndexOptionUpdate = [["#", "randomRow"], ["All", "allRow"]];
  let controlsInsideRT: any = [['Select Control', 'Select Control']]

  let allSystemFieldsDataType = {};
  let allSystemFieldsData = [];
  systemSingleValue.forEach(systemField => {
    if(ExcludedSystemFields.indexOf(systemField.value) == -1) {
      allSystemFieldsData.push({key: systemField.key, value: systemField.value});
      let type = 'STRING';
      if(DateSystemFields.indexOf(systemField.value) != -1) {
        type = 'DATE';
      }else if(BooleanSystemFields.indexOf(systemField.value) != -1) {
        type = 'BOOLEAN';
      }
      
      allSystemFieldsDataType[systemField.value] = type;
    }
  });

  let projectNames = [['Select Project', '']];
  let appbuilderID = [['Select Form Name', '']];

  if (projectsLists && projectsLists.length > 0) {
    projectsLists.splice(projectsLists.findIndex(el => el.value === 'Project Templates'), 1);
    projectNames.push(['Current Project', 'Current Project']);
    let sortProject = [];
    for (let i = 0; i < projectsLists.length; i++) {
      sortProject.push([projectsLists[i].value, projectsLists[i].value]);
    }
    sortProject = _.sortBy(sortProject, [project => project[0].toLowerCase()], ['asce']);
    sortProject.map((array)=> projectNames.push(array));
  }

  const spUserDetailsOptions = [['Select Type', ''], ['Username & Organisation', 'Value2'], ['Organisation', 'Value3'], ['User Role', 'Value4'], ['Contact No', 'Value5'],  ['Email', 'Value6'], ['First Name', 'Value7'], ['Last Name', 'Value8'], ['Designation', 'Name']];

  let SystemFieldNameOptions = [['Select System Field Name...', '']];
  let sortSystemFields = _.sortBy(allSystemFieldsData, function(field) {
    return field.key.toLowerCase();
  });
  sortSystemFields.forEach(field => {
    SystemFieldNameOptions.push([field.key, field.value]);
  });

  const CurrentDateFieldOptions = [['Select Type...', ''],['Date','date'],['Date & Time','datetime'],['Time','time']];

  let PropertyNameOptions = {};
  for(let key in PropertyDetail) {
    let sortProperties = _.sortBy(PropertyDetail[key]);
    PropertyNameOptions[key] = [];
    sortProperties.forEach((item) => {
      PropertyNameOptions[key].push(item);
    });
  }

  let isRepeatingTableControl = (controlName, list) => {
    let isTableControl = false;
    if(controlName) {
      list.some(field => {
        if(field.key === controlName && field.parent == 'repeating-table' ) {
          isTableControl = true;
          return true;
        }
      });
    }
    return isTableControl;
  }

  let refreshScopeInputField = (control, oldControlName, newControlName, list) => {
    if(isRepeatingTableControl(oldControlName, list) && !isRepeatingTableControl(newControlName, list)) {
      control.removeInput('SCOPE_DATA', true);
    }else if(!isRepeatingTableControl(oldControlName, list) && isRepeatingTableControl(newControlName, list)) {
      control.appendValueInput('SCOPE_DATA').appendField("   Scope: ", 'SCOPE');
    }
  }

  let getControlType = (controlName) => {
    let controlType = '';
    if(controlName) {
      customFields.some(field => {
        if(!controlType && field.key === controlName) {
          controlType = field.type;
          return true;
        }
      });
    }

    return controlType;
  }

  let refreshDropdownInputField = (block) => {
    let input = block.getInput('CUSTOM_RESPONSE');
    if (block && block.parentBlock_) {
      let propName = block.parentBlock_ ? block.parentBlock_.getFieldValue('PROPERTY_NAME') : ' ';
      if (propName == 'options') {
        if (block && block.childBlocks_ && block.childBlocks_[0] && block.childBlocks_[0].getVarModels()[0] && block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']) {
          if(!block.getField('KEY_NAME')) {
            input.appendField(" Option Map ", 'SET_KEY');
            input.appendField(new Blockly.FieldDropdown(block.generateOptions.bind(block)), 'KEY_NAME');
          }
         }
      }else {
        input.removeField("SET_KEY",true);
        input.removeField("KEY_NAME",true);
      } 
    }
  }

  let refreshDropdownNewInputField = (block) => {
    let inputNew = block.getInput('New_CUSTOM_RESPONSE');
    if (block && block.parentBlock_) {
      let propName = block.parentBlock_ ? block.parentBlock_.getFieldValue('PROPERTY_NAME') : ' ';
        if (propName == 'options' && inputNew) {
          if (block && block.childBlocks_ && block.childBlocks_[0] && block.childBlocks_[0].getVarModels()[0] && block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']) {
            if (!block.getField('VALUE_NAME')) {
              inputNew.appendField(" Value", 'SET_VALUE')
              inputNew.appendField(new Blockly.FieldDropdown(block.generateOptions.bind(block)), 'VALUE_NAME')
            }
            if (!block.getField('NAME_MAP')) {
              inputNew.appendField(" Display Name", 'SET_KEY_NAME');
              inputNew.appendField(new Blockly.FieldDropdown(block.generateOptions.bind(block)), 'NAME_MAP');
            }
          }
        } else {
          inputNew.removeField("SET_VALUE", true);
          inputNew.removeField("VALUE_NAME", true);
          inputNew.removeField("SET_KEY_NAME", true);
          inputNew.removeField("NAME_MAP", true);
        }
      }
    
  }

  /**
   * Custom property setter block
   */
  Blockly.Blocks['custom-property-setter'] = {
    init: function() {
      this.appendDummyInput('CUSTOM_PROP_SETTER_DUMMY_INPUT')
        .appendField("Setter : Control Name:")
        .appendField(new Blockly.FieldDropdown(ControlNameOptions, this.validateControlName), 'CONTROL_NAME')
        .appendField("Property Name:")
        .appendField(new Blockly.FieldDropdown([['', '']], this.validatePropertyName), "PROPERTY_NAME")
        .appendField("Value:")
        .appendField(new Blockly.FieldTextInput(""), "PROPERTY_VALUE");
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(Blockly.Msg.PROCEDURES_HUE);
      this.setTooltip("Set element custom property value");
      this.setHelpUrl("");
    },

    validateControlName: function(controlName) {
      let block = this.getSourceBlock();
      if(block.controlName != controlName) {
        let oldControlName = block.controlName;
        block.controlName = controlName;
        if(!oldControlName) {
          block.onControlNameChanged(controlName, oldControlName);
        } else {
          setTimeout(() => {
            block.onControlNameChanged(controlName, oldControlName);
          }, 50);
        }
      }
      return controlName;
    },

    validatePropertyName: function(propName) {
      let block = this.getSourceBlock();
      let oldPropName = block.propName;
      block.propName = propName;
      if(!oldPropName) {
        block.appendPropertyValueField(propName);
      } else {
        setTimeout(() => {
          block.appendPropertyValueField(propName);
        }, 50);
      }
      return propName;
    },

    onControlNameChanged: function(controlName, oldControlName) {
      let input = this.getInput('CUSTOM_PROP_SETTER_DUMMY_INPUT');
      input.removeField('PROPERTY_NAME', true);
      let options = this.getPropertyNameOptions(controlName);
      if(options[0][1] != '') {
        input.insertFieldAt(3, new Blockly.FieldDropdown(options, this.validatePropertyName), "PROPERTY_NAME");
      }
      this.appendPropertyValueField(options[0][1]);

      refreshScopeInputField(this, oldControlName, controlName, customFields);
      
    },

    getPropertyNameOptions: function(controlName) {
      let controlType = getControlType(controlName);
      let options = angular.copy(PropertyNameOptions[controlType] || [['', '']]);
      if(controlType == 'Radio' || controlType == 'Dropdown' || controlType == 'Checkbox') {
        options.some((otion, index) => {
          if(otion[0] == 'Options') {
            options.splice(index, 1);
            return true;
          }
        });
      }
      return options;
    },

    appendPropertyValueField: function(propertyName) {
      let input = this.getInput('CUSTOM_PROP_SETTER_DUMMY_INPUT');
      input.removeField('PROPERTY_VALUE', true);
      input.removeField('PROPERTY_VALUE_MONTH', true);
      input.removeField('PROPERTY_VALUE_YEAR', true);
      input.removeField('PROPERTY_VALUE_HOUR', true);
      input.removeField('PROPERTY_VALUE_MINUTES', true);
      input.removeField('PROPERTY_VALUE_MERIDIAN', true);
      input.removeField('DATE', true);
      input.removeField('MONTH', true);
      input.removeField('YEAR', true);
      input.removeField('HOUR', true);
      input.removeField('MINUTES', true);
      input.removeField('MERIDIAN', true);
      
      if(!propertyName) {
        return;
      }
      let type = PropertyType[propertyName] || '';
      if(type == 'BOOLEAN') {
        input.appendField(new Blockly.FieldCheckbox(true), 'PROPERTY_VALUE');
        return;
      }

      if (type == 'NUMBER') {
        let number = 0;
        if(propertyName == 'font-size' || propertyName == 'label-font-size' || propertyName == 'control-font-size') {
          number = 16;
        } else if(propertyName == 'padding-top' || propertyName == 'padding-bottom' || propertyName == 'padding-left' || propertyName == 'padding-right') {
          number = 5;
        } else if(propertyName == 'borderWidth') {
          number = 1;
        } else if(propertyName == 'width' || propertyName == 'height') {
          number = 100;
        } else if(propertyName == 'charLimit') {
          number = 25;
        } else if(propertyName == 'size') {
          number = 3;
        }
        input.appendField(new Blockly.FieldNumber(number, 0, Infinity, 1), 'PROPERTY_VALUE');
        return;
      }

      if(type.indexOf('_DROPDOWN') != -1) {
        input.appendField(new Blockly.FieldDropdown(PropertyTypeDropdown[type]), 'PROPERTY_VALUE');
        return;
      }

      if(type == 'COLOR_PICKER') {
        input.appendField(new Blockly.FieldColour('#ffffff'), 'PROPERTY_VALUE');
        return;
      }

      let controlType = getControlType(this.controlName);
      if(controlType == 'Textarea' || controlType == 'RichTextArea') {
        input.appendField(new Blockly.FieldMultilineInput(""), "PROPERTY_VALUE");
        return;
      }

      if(controlType == 'Datepicker' && propertyName == 'value' ) {
        let date = new Date();
        input.appendField("Date", 'DATE');
        input.appendField(new Blockly.FieldNumber(date.getDate(), 0, 31, 1), "PROPERTY_VALUE");
        input.appendField("Month", 'MONTH');
        input.appendField(new Blockly.FieldNumber(date.getMonth() + 1, 1, 12, 1), "PROPERTY_VALUE_MONTH");
        input.appendField("Year", 'YEAR');
        input.appendField(new Blockly.FieldNumber(date.getFullYear(), 0, 9999, 1), "PROPERTY_VALUE_YEAR");
        input.appendField("Hour", 'HOUR');
        input.appendField(new Blockly.FieldNumber(date.getHours(), 0, 12, 1), "PROPERTY_VALUE_HOUR");
        input.appendField("Minutes", 'MINUTES');
        input.appendField(new Blockly.FieldNumber(date.getMinutes(), 0, 60, 1), "PROPERTY_VALUE_MINUTES");
        input.appendField("AM/PM", 'MERIDIAN');
        input.appendField(new Blockly.FieldDropdown([['AM','AM'],['PM','PM']]), "PROPERTY_VALUE_MERIDIAN");
        return;
      }

      if(controlType == 'Timepicker' && propertyName == 'value' ) {
        let date = new Date();
        input.appendField("Hour", 'HOUR');
        input.appendField(new Blockly.FieldNumber(date.getHours(), 0, 12, 1), "PROPERTY_VALUE_HOUR");
        input.appendField("Minutes", 'MINUTES');
        input.appendField(new Blockly.FieldNumber(date.getMinutes(), 0, 60, 1), "PROPERTY_VALUE_MINUTES");
        input.appendField("AM/PM", 'MERIDIAN');
        input.appendField(new Blockly.FieldDropdown([['AM','AM'],['PM','PM']]), "PROPERTY_VALUE_MERIDIAN");
        return;
      }

      input.appendField(new Blockly.FieldTextInput(""), "PROPERTY_VALUE");
    }

  };
    
  Blockly['JavaScript']['custom-property-setter'] = function(block) {
    let controlName = block.getFieldValue('CONTROL_NAME') || '';
    let propName = block.getFieldValue('PROPERTY_NAME') || '';
    let propValue;
    if(block.getFieldValue('PROPERTY_VALUE') == 0){
      propValue = 0 ;  
    } else{
       propValue = block.getFieldValue('PROPERTY_VALUE') || '';
    }
    let scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || '';

    let code = '';
    if(PropertyType[propName] == 'BOOLEAN') {
      propValue = (propValue == 'TRUE') ? true : false;
      code = ` (window.setPropValue && window.setPropValue('${controlName}', '${propName}', ${propValue}, ${scopeData}));\n`;
    } else if(PropertyType[propName] == 'NUMBER') {
      code = ` (window.setPropValue && window.setPropValue('${controlName}', '${propName}', ${propValue}, ${scopeData}));\n`;
    } else if(PropertyType[propName] == 'FONT_WEIGHT_DROPDOWN' || PropertyType[propName] == 'FONT_STYLE_DROPDOWN' || PropertyType[propName] == 'TEXT_DECORATION_DROPDOWN') {
      propValue = (propValue == '') ? false : true;
      code = ` (window.setPropValue && window.setPropValue('${controlName}', '${propName}', ${propValue}, ${scopeData}));\n`;
    } else if(getControlType(controlName) == 'Datepicker' && propName == 'value') {
      let year = block.getFieldValue('PROPERTY_VALUE_YEAR');
      let month = block.getFieldValue('PROPERTY_VALUE_MONTH');
      let hours = block.getFieldValue('PROPERTY_VALUE_HOUR');
      let minutes = block.getFieldValue('PROPERTY_VALUE_MINUTES');
      let meridian = block.getFieldValue('PROPERTY_VALUE_MERIDIAN');
      if(propValue != 0 && month != 0 && year != 0){
        propValue = `${year}-${month}-${propValue} ${hours}:${minutes} ${meridian}`;
      }else {
        propValue = '';
      }
      code = ` (window.setPropValue && window.setPropValue('${controlName}', '${propName}', "${propValue}", ${scopeData}));\n`;
    } else if(getControlType(controlName) == 'Timepicker' && propName == 'value') {
      let year = new Date().getFullYear();
      let month = new Date().getMonth();
      let date = new Date().getDate();
      let hours = block.getFieldValue('PROPERTY_VALUE_HOUR');
      let minutes = block.getFieldValue('PROPERTY_VALUE_MINUTES');
      let meridian = block.getFieldValue('PROPERTY_VALUE_MERIDIAN')
      if((hours || hours == 0) && (minutes || minutes == 0)){
        propValue = `${year}-${month}-${date} ${hours}:${minutes} ${meridian}`;
      }else {
        propValue = '';
      }
      code = ` (window.setPropValue && window.setPropValue('${controlName}', '${propName}', "${propValue}", ${scopeData}));\n`;
    } else {
      if(propValue.search && propValue.search(/\n/) != -1) {
        let controlType = getControlType(controlName);
        if(controlType == 'RichTextArea') {
          propValue = propValue.replace(/\n/g, '<br />');
        }else {
          propValue = propValue.replace(/\n/g, '$#$#$#');
        }
      }
      code = ` (window.setPropValue && window.setPropValue('${controlName}', '${propName}', "${propValue}", ${scopeData}));\n`;
    }
    return code;
  };
  

  /**
   * Custom property setter block using any getter method
   */
  Blockly.Blocks['custom-property-setter_by_getter'] = {
    init: function() {
      this.appendDummyInput('CUSTOM_PROP_SETTER_DUMMY_INPUT')
        .appendField("Setter : Control Name:")
        .appendField(new Blockly.FieldDropdown(ControlNameOptions, this.validateControlName), 'CONTROL_NAME')
        .appendField("Property Name:")
        .appendField(new Blockly.FieldDropdown([['', '']]), "PROPERTY_NAME")
        .appendField("Value:")
      this.appendValueInput('PROPERTY_VALUE_INPUT').setCheck(null);
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(Blockly.Msg.PROCEDURES_HUE);
      this.setTooltip("Set element custom property value using getter method");
      this.setHelpUrl("");
    },

    validateControlName: function(controlName) {
      if(this.controlName != controlName) {
        let oldControlName = this.controlName;
        this.controlName = controlName;
        if(!oldControlName) {
          this.getSourceBlock().onControlNameChanged(controlName, oldControlName);
        } else {
          setTimeout(() => {
            this.getSourceBlock().onControlNameChanged(controlName, oldControlName);
          }, 50);
        }
      }
      return controlName;
    },

    onControlNameChanged: function(controlName, oldControlName) {
      let input = this.getInput('CUSTOM_PROP_SETTER_DUMMY_INPUT');
      input.removeField('PROPERTY_NAME', true);
      let options = this.getPropertyNameOptions(controlName);
      if (options[0][1] != '') {
        let controlType = getControlType(controlName);
        if(controlType == 'Dropdown' || controlType == 'MultiDropdown') {
          options[0][0] = 'Options';
          options[0][1] = 'options'
        }
        input.insertFieldAt(3, new Blockly.FieldDropdown(options), "PROPERTY_NAME");
      }

      refreshScopeInputField(this, oldControlName, controlName, customFields);
    },

    getPropertyNameOptions: function(controlName) {
      let controlType = getControlType(controlName);
      return angular.copy(PropertyNameOptions[controlType] || [['', '']]);
    }

  };
    
  Blockly['JavaScript']['custom-property-setter_by_getter'] = function(block) {
    let controlName = block.getFieldValue('CONTROL_NAME') || '';
    let propName = block.getFieldValue('PROPERTY_NAME') || '';
    let propValue = Blockly['JavaScript'].valueToCode(block, 'PROPERTY_VALUE_INPUT', Blockly['JavaScript'].ORDER_NONE) || '';
    let scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || '';

    let code = '';
    if(propValue.indexOf('window.') != -1) {
      code = ` (window.setPropValue && window.setPropValue('${controlName}', '${propName}', ${propValue}, ${scopeData})); \n`;
    } else {
      if(PropertyType[propName] == 'BOOLEAN') {
        propValue = (propValue == 'TRUE' || propValue == 'true' || propValue == true) ? true : false;
      } else if(PropertyType[propName] == 'NUMBER') {
        propValue = parseInt(propValue);
      } else if(PropertyType[propName] == 'FONT_WEIGHT_DROPDOWN' || PropertyType[propName] == 'FONT_STYLE_DROPDOWN' || PropertyType[propName] == 'TEXT_DECORATION_DROPDOWN') {
        propValue = (propValue == '' || propValue == 'false' || propValue == false ) ? false : true;
      }
      code = ` (window.setPropValue && window.setPropValue('${controlName}', '${propName}', ${propValue}, ${scopeData}));\n`;
    }

    return code;
  };

  
  /**
   * Custom property setter block using any getter method
   */
  Blockly.Blocks['custom-property-value-setter'] = {
    init: function() {
      this.appendDummyInput('CUSTOM_PROP_VALUE_SETTER_DUMMY_INPUT')
        .appendField("Set Value : Control Name:")
        .appendField(new Blockly.FieldDropdown(ControlDataFieldNameOptions, this.validateControlName), 'CONTROL_NAME')
        .appendField("Value:")
      this.appendValueInput('PROPERTY_VALUE_INPUT').setCheck(null);
      this.appendDummyInput('CUSTOM_PROP_VALUE_SETTER_DUMMY_INPUT_FOR_DATE');
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(Blockly.Msg.PROCEDURES_HUE);
      this.setTooltip("Set element custom property value.");
      this.setHelpUrl("");
    },
    
    validateControlName: function(controlName) {
      let block = this.getSourceBlock();
      if(block.controlName != controlName) {
        let oldControlName = block.controlName;
        block.controlName = controlName;
        if(!oldControlName) {
          block.appendPropertyValueField(controlName, oldControlName);
        } else {
          setTimeout(() => {
            block.appendPropertyValueField(controlName, oldControlName);
          }, 50);
        }
      }
      return controlName;
    },

    getTwelveHourTime: function (){
      let date = new Date();                                  //  For converting 24 hour time to 12 hour clock time.
      let twelveHourTime: number;
        if(date.getHours()<13){
          twelveHourTime=date.getHours();
        }
        else{
          twelveHourTime=date.getHours()-12;
        }
      return twelveHourTime;
    },
    getAdjustedTimeObjectForAmPm: function (){
      let date = new Date();                                  //  For getting PM or AM object as per current time returned by getHours()
      let AmPmObject: {};                                     //  To be used for automatic default selection of AM or PM in dropdown.
      if(date.getHours()<12){
        AmPmObject=['AM', 'AM'];
        }else{
        AmPmObject=['PM', 'PM'];
        }
      return AmPmObject;
    },
    
    appendPropertyValueField: function(controlName, oldControlName) {
      let input = this.getInput('CUSTOM_PROP_VALUE_SETTER_DUMMY_INPUT_FOR_DATE');
      let controlType = getControlType(controlName);
      let isDatePickerControl = controlType == 'Datepicker';
      let isTimePickerControl = controlType == 'Timepicker';
      refreshScopeInputField(this, oldControlName, controlName, dataFieldNames);
      if(!controlName || isDatePickerControl != this.isDatePickerControl || isTimePickerControl != this.isTimePickerControl) {
        input.removeField('PROPERTY_VALUE', true);
        input.removeField('PROPERTY_VALUE_MONTH', true);
        input.removeField('PROPERTY_VALUE_YEAR', true);
        input.removeField('PROPERTY_VALUE_HOUR', true);
        input.removeField('PROPERTY_VALUE_MINUTES', true);
        input.removeField('PROPERTY_VALUE_MERIDIAN', true);
        input.removeField('DATE', true);
        input.removeField('MONTH', true);
        input.removeField('YEAR', true);
        input.removeField('HOUR', true);
        input.removeField('MINUTES', true);
        input.removeField('MERIDIAN', true);
        input.removeField('OR', true);
      }
      
      if(!controlName || (this.isDatePickerControl == isDatePickerControl && !isTimePickerControl)) {
        return;
      }
      this.isDatePickerControl = isDatePickerControl;
      if(isDatePickerControl ) {
        let date = new Date();
        input.appendField("   OR   ", 'OR');
        input.appendField("Date", 'DATE');
        input.appendField(new Blockly.FieldNumber(date.getDate(), 0, 31, 1), "PROPERTY_VALUE");
        input.appendField("Month", 'MONTH');
        input.appendField(new Blockly.FieldNumber(date.getMonth() + 1, 0, 12, 1), "PROPERTY_VALUE_MONTH");
        input.appendField("Year", 'YEAR');
        input.appendField(new Blockly.FieldNumber(date.getFullYear(), 0, 9999, 1), "PROPERTY_VALUE_YEAR");
        input.appendField("Hour", 'HOUR');
        input.appendField(new Blockly.FieldNumber(this.getTwelveHourTime(), 0, 12, 1), "PROPERTY_VALUE_HOUR");
        input.appendField("Minutes", 'MINUTES');
        input.appendField(new Blockly.FieldNumber(date.getMinutes(), 0, 60, 1), "PROPERTY_VALUE_MINUTES");
        input.appendField("AM/PM", 'MERIDIAN');
        if(this.getAdjustedTimeObjectForAmPm()[0]=='AM'){
          input.appendField(new Blockly.FieldDropdown([['AM', 'AM'], ['PM', 'PM']]), "PROPERTY_VALUE_MERIDIAN");
        }
        else{
          input.appendField(new Blockly.FieldDropdown([['PM', 'PM'], ['AM', 'AM']]), "PROPERTY_VALUE_MERIDIAN");
        }
        input.fieldRow[12].selectedOption_=this.getAdjustedTimeObjectForAmPm();                                   //  For setting the selected value of dropdown field 
        input.fieldRow[12].value_=input.fieldRow[12].selectedOption_[0];                                          //  with AM or PM as per current time.
      }

      if(!controlName || this.isTimePickerControl == isTimePickerControl) {
        return;
      }
      this.isTimePickerControl = isTimePickerControl;
      if(isTimePickerControl) {
        let date = new Date();
        input.appendField("   OR   ", 'OR');
        input.appendField("Hour", 'HOUR');
        input.appendField(new Blockly.FieldNumber(this.getTwelveHourTime(), 0, 12, 1), "PROPERTY_VALUE_HOUR");
        input.appendField("Minutes", 'MINUTES');
        input.appendField(new Blockly.FieldNumber(date.getMinutes(), 0, 60, 1), "PROPERTY_VALUE_MINUTES");
        input.appendField("AM/PM", 'MERIDIAN');
        if(this.getAdjustedTimeObjectForAmPm()[0]=='AM'){
          input.appendField(new Blockly.FieldDropdown([['AM', 'AM'], ['PM', 'PM']]), "PROPERTY_VALUE_MERIDIAN");
        }
        else{
          input.appendField(new Blockly.FieldDropdown([['PM', 'PM'], ['AM', 'AM']]), "PROPERTY_VALUE_MERIDIAN");
        }
         input.fieldRow[6].selectedOption_=this.getAdjustedTimeObjectForAmPm();                                    //  For setting the selected value of dropdown field
        input.fieldRow[6].value_=input.fieldRow[6].selectedOption_[0];                                            //  with AM or PM as per current time.
      }
    }

  };
    
  Blockly['JavaScript']['custom-property-value-setter'] = function(block) {
    let controlName = block.getFieldValue('CONTROL_NAME') || '';
    let propValue = Blockly['JavaScript'].valueToCode(block, 'PROPERTY_VALUE_INPUT', Blockly['JavaScript'].ORDER_NONE) || '';
    let code = '';
    let scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || '';
    if(getControlType(controlName) == 'Datepicker') {  
      let year = block.getFieldValue('PROPERTY_VALUE_YEAR');
      let month = block.getFieldValue('PROPERTY_VALUE_MONTH');
      let date = block.getFieldValue('PROPERTY_VALUE');
      let hours = block.getFieldValue('PROPERTY_VALUE_HOUR');
      let minutes = block.getFieldValue('PROPERTY_VALUE_MINUTES');
      let meridian = block.getFieldValue('PROPERTY_VALUE_MERIDIAN');
      let propValueTrimLength = propValue && propValue.replace && propValue.replace(/'/g, '').trim().length;
      if(propValueTrimLength) {
        code = ` (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('${controlName}', ${propValue},'', ${scopeData}));\n`;
      }else if(date != 0 && month != 0 && year != 0){
        propValue = `${year}-${month}-${date} ${hours}:${minutes} ${meridian}`;
        code = ` (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('${controlName}', "${propValue}",'', ${scopeData}));\n`;
      }else {
        code = ` (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('${controlName}', '', ${scopeData}));\n`;
      }
    }else if(getControlType(controlName) == 'Timepicker') {
      let year = new Date().getFullYear();;
      let month = new Date().getMonth();;
      let date = new Date().getDate();
      let hours = block.getFieldValue('PROPERTY_VALUE_HOUR');
      let minutes = block.getFieldValue('PROPERTY_VALUE_MINUTES');
      let meridian = block.getFieldValue('PROPERTY_VALUE_MERIDIAN');
      let propValueTrimLength = propValue && propValue.replace && propValue.replace(/'/g, '').trim().length;
      if(propValueTrimLength) {
        code = ` (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('${controlName}', ${propValue}, '',${scopeData}));\n`;
      }else if((hours || hours == 0) && (minutes || minutes == 0)){
        propValue = `${year}-${month}-${date} ${hours}:${minutes} ${meridian}`;
        code = ` (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('${controlName}', "${propValue}",'', ${scopeData}));\n`;
      }else {
        code = ` (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('${controlName}', '', ${scopeData}));\n`;
      }
    }else {
      if(propValue.indexOf('window.') != -1) {
        code = ` (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('${controlName}', ${propValue},'', ${scopeData})); \n`;
      }else {
        code = ` (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('${controlName}', ${propValue},'', ${scopeData}));\n`;
      }
    }
    return code;
  };


  /**
   * Custom property getter block
   */
  Blockly.Blocks['custom-property-getter'] = {
    init: function() {
      this.appendDummyInput("CUSTOM_PROP_GETTER_DUMMY_INPUT")
        .appendField("Getter: Control Name:")
        .appendField(new Blockly.FieldDropdown(ControlNameOptions, this.validateControlName), 'CONTROL_NAME')
        .appendField("Property Name:")
        .appendField(new Blockly.FieldDropdown([['', '']]), "PROPERTY_NAME");
      this.setInputsInline(true);
      this.setOutput(true);
      this.setColour(Blockly.Msg.PROCEDURES_HUE);
      this.setTooltip("Get element custom property value");
      this.setHelpUrl("");
    },

    validateControlName: function(controlName) {
      if(this.controlName != controlName) {
        let oldControlName = this.controlName;
        this.controlName = controlName;
        if(!oldControlName) {
          this.getSourceBlock().updateConnections(controlName, oldControlName);
        } else {
          setTimeout(() => {
            this.getSourceBlock().updateConnections(controlName, oldControlName);
          }, 50);
        }
      }
      return controlName;
    },

    updateConnections: function(controlName, oldControlName) {
      let input = this.getInput('CUSTOM_PROP_GETTER_DUMMY_INPUT');
      input.removeField('PROPERTY_NAME', true);
      let options = this.getPropertyNameOptions(controlName);
      if(options[0][1] != '') {
        input.appendField(new Blockly.FieldDropdown(options), "PROPERTY_NAME");
      }
      
      refreshScopeInputField(this, oldControlName, controlName, customFields);

    },

    getPropertyNameOptions: function(controlName) {
      return PropertyNameOptions[getControlType(controlName)] || [['', '']];
    }
    
  };

  Blockly['JavaScript']['custom-property-getter'] = function(block) {
    let controlName = block.getFieldValue('CONTROL_NAME') || '';
    let propName = block.getFieldValue('PROPERTY_NAME') || '';
    let scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || '';
    let code = ` (window.getPropValue && window.getPropValue('${controlName}', '${propName}', ${scopeData})) `;
    return [code, Blockly['JavaScript'].ORDER_VOID];
  };

   /**
   * Custom property value getter block
   */
  Blockly.Blocks['custom-property-value-getter'] = {
    init: function() {
      this.appendDummyInput("CUSTOM_PROP_VALUE_GETTER_DUMMY_INPUT")
        .appendField("Get Value: Control Name:")
        .appendField(new Blockly.FieldDropdown(ControlDataFieldNameOptions, this.validateControlName), 'CONTROL_NAME')
      this.setInputsInline(true);
      this.setOutput(true);
      this.setColour(Blockly.Msg.PROCEDURES_HUE);
      this.setTooltip("Get element custom property value");
      this.setHelpUrl("");
    },

    validateControlName: function(controlName) {
      if(this.controlName != controlName) {
        let oldControlName = this.controlName;
        this.controlName = controlName;
        if(!oldControlName) {
          this.getSourceBlock().updateConnections(controlName, oldControlName);
        } else {
          setTimeout(() => {
            this.getSourceBlock().updateConnections(controlName, oldControlName);
          }, 50);
        }
      }
      return controlName;
    },

    updateConnections: function(controlName, oldControlName) {
      refreshScopeInputField(this, oldControlName, controlName, dataFieldNames);
    }
  };

  Blockly['JavaScript']['custom-property-value-getter'] = function(block) {
    let controlName = block.getFieldValue('CONTROL_NAME') || '';
    let scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || '';
    let code = ` (window.getPropValueByDataFieldName && window.getPropValueByDataFieldName('${controlName}', ${scopeData})) `;
    return [code, Blockly['JavaScript'].ORDER_VOID];
  };

     /**
 * RepeatingTable Sequence blockly
 */
  Blockly.Blocks['repeating-table-control-sequence'] = {
    init: function () {
      this.appendDummyInput('REPEATING_TABLE_SEQUENCE')
        .appendField("Repeating Table Row Sequence")
        .appendField(new Blockly.FieldDropdown(RepeatingTableControlNameOptions, this.validateControlName), 'TABLE_NAME')
        .appendField("ControlName ")
        .appendField(new Blockly.FieldDropdown(controlsInsideRT), 'CONTROLS_INSIDE_RT')
        .appendField("Start Number: ")
        .appendField(new Blockly.FieldNumber(0, 0, 2000, 1), "START_NUMBER")
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(120);
      this.setTooltip("repeating table sequence.");
      this.setHelpUrl("");
    },
    validateControlName: function (controlName) {
      if (this.controlName != controlName) {
        let oldControlName = this.controlName;
        this.controlName = controlName;
        if (!oldControlName) {
          this.getSourceBlock().updateConnections(controlName,oldControlName);
          this.getSourceBlock().onControlNameChanged(controlName);
        } else {
          setTimeout(() => {
          this.getSourceBlock().updateConnections(controlName,oldControlName);
            this.getSourceBlock().onControlNameChanged(controlName);
          }, 50);
        }
      }
      return controlName;
    },
    updateConnections: function (controlName, oldControlName) {
      refreshScopeInputField(this, oldControlName, controlName, customFields);
    },
    onControlNameChanged: function (controlName,oldControlName) {
      let input = this.getInput('REPEATING_TABLE_SEQUENCE');
      let controls:any = customFields.filter((control) => control.type == 'Textbox' || control.type == 'Textarea')
      if (!controlName || !controls || !controls.length) {
        input.removeField('CONTROLS_INSIDE_RT', true);
        input.insertFieldAt(3, new Blockly.FieldDropdown([['Select Control', 'Select Control']]), "CONTROLS_INSIDE_RT");
      } else {
          controlsInsideRT = controls.map((item) => [item.key, item.key]);
          input.removeField('CONTROLS_INSIDE_RT', true);
          input.insertFieldAt(3, new Blockly.FieldDropdown(controlsInsideRT), "CONTROLS_INSIDE_RT");
      }
    },
  }
  Blockly['JavaScript']['repeating-table-control-sequence'] = function (block) {
    let TableName = block.getFieldValue('TABLE_NAME') || '';
    let controlName = block.getFieldValue('CONTROLS_INSIDE_RT')
    let startNumber = block.getFieldValue('START_NUMBER')
    let scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || 'null';
    let code = ` window.repeatingTableInsertNumber && window.repeatingTableInsertNumber('${TableName}','${controlName}','${startNumber - 1}',${scopeData});\n `;
    return code
  };

  /**
   * Custom control to reset repeating table value
   */
  Blockly.Blocks['custom-reset-repeating-table'] = {
    init: function() {
      this.appendDummyInput('CUSTOM_REPEATING_TABLE_DUMMY_INPUT')
        .appendField("Reset Repeating Table : Control Name:")
        .appendField(new Blockly.FieldDropdown(RepeatingTableControlNameOptions), 'CONTROL_NAME');
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(120);
      this.setTooltip("Reset selected repeating table value.");
      this.setHelpUrl("");
    }
  };
    
  Blockly['JavaScript']['custom-reset-repeating-table'] = function(block) {
    let controlName = block.getFieldValue('CONTROL_NAME') || '';
    let code = ` (window.resetRepeatingTableValue && window.resetRepeatingTableValue('${controlName}')); \n `;
    return code;
  };

  /**
   * Custom console.log blog
   */
  Blockly.Blocks['text_console'] = {
    init: function() {
      this.appendValueInput("TEXT")
          .setCheck(null)
          .appendField("Console Log")
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(160);
      this.setTooltip("");
      this.setHelpUrl("");
    }
  };

  Blockly['JavaScript']['text_console'] = function(block) {
    let value_name = Blockly['JavaScript'].valueToCode(block, 'TEXT', Blockly['JavaScript'].ORDER_ATOMIC);
    return ` window.console && window.console.log && window.console.log(${value_name}); \n`;
  };

  /**
   * Custom Json stringify and parser block
   */
  Blockly.Blocks['json_stringify'] = {
    init: function() {
      this.appendValueInput("STING_JSON_CONVERTER")
        .setCheck(null)
        .appendField("Convert To:")
        .appendField(new Blockly.FieldDropdown([["String", "STRING"], ["JSON", "JSON"]]), "CONVERT_TYPE");
      this.setInputsInline(true);
      this.setOutput(true, null);
      this.setColour(160);
      this.setTooltip("");
      this.setHelpUrl("");
    }
  };
  
  Blockly['JavaScript']['json_stringify'] = function(block) {
    let convertType = block.getFieldValue('CONVERT_TYPE');
    let value = Blockly['JavaScript'].valueToCode(block, 'STING_JSON_CONVERTER', Blockly['JavaScript'].ORDER_ATOMIC);
    let code = '';
    if(convertType == 'STRING') {
      code = ' JSON.stringify('+value+') ';
    }else {
      code = ' JSON.parse('+value+') ';
    }
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };

  /**
   * Parse string to number
   */
  Blockly.Blocks['parse_to_number'] = {
    init: function() {
      this.appendValueInput("PARSE_TO_NUMBER")
        .setCheck(null)
        .appendField("Parse To Number:");
      this.setInputsInline(true);
      this.setOutput(true, null);
      this.setColour(230);
      this.setTooltip("It parses a string and returns a number.");
      this.setHelpUrl("");
    }
  };
  
  Blockly['JavaScript']['parse_to_number'] = function(block) {
    let value = Blockly['JavaScript'].valueToCode(block, 'PARSE_TO_NUMBER', Blockly['JavaScript'].ORDER_ATOMIC);
    let code = ` isNaN(parseFloat(${value})) ? ${value} : parseFloat(${value}) `;
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };

  /**
   * Custom Blockly component to set time out to execute some block of script code
   */
  Blockly.Blocks['set_timeout'] = {
    init: function() {
      this.appendDummyInput()
        .appendField("setTimeout by")
        .appendField(new Blockly.FieldNumber(0, 0, 60000, 1), "TIME");
      this.appendStatementInput("TIMEOUT_HANDLER")
        .setCheck(null);
      this.setInputsInline(false);
      this.setOutput(true, null);
      this.setColour(290);
      this.setTooltip("");
      this.setHelpUrl("");
    }
  };

  Blockly['JavaScript']['set_timeout'] = function(block) {
    let time = block.getFieldValue('TIME');
    let timeoutHhandler = Blockly['JavaScript'].statementToCode(block, 'TIMEOUT_HANDLER');
    let code = ` window.setTimeout(function() {
      ${timeoutHhandler}
    }, ${time}) `
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };

  /**
   * Custom Blockly component to set some interval to execute some block of script code
   */
  Blockly.Blocks['set_time_interval'] = {
    init: function() {
      this.appendDummyInput()
        .appendField("setInterval by")
        .appendField(new Blockly.FieldNumber(0, 0, 60000, 1), "TIME");
      this.appendStatementInput("TIMEINTERVAL_HANDLER")
        .setCheck(null);
      this.setInputsInline(false);
      this.setOutput(true, null);
      this.setColour(290);
      this.setTooltip("");
      this.setHelpUrl("");
    }
  };

  Blockly['JavaScript']['set_time_interval'] = function(block) {
    let time = block.getFieldValue('TIME');
    let timeoutHhandler = Blockly['JavaScript'].statementToCode(block, 'TIMEINTERVAL_HANDLER');
    let code = ` window.setInterval(function() {
      ${timeoutHhandler}
    }, ${time}) `
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };

  /**
   * Custom Blockly component to clear time out
   */
  Blockly.Blocks['clear_timeout'] = {
    init: function() {
      this.appendValueInput("TIMEOUT_ID")
        .setCheck(null)
        .appendField("Clear timeout ");
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(290);
      this.setTooltip("");
      this.setHelpUrl("");
    }
  };

  Blockly['JavaScript']['clear_timeout'] = function(block) {
    let timerId = Blockly['JavaScript'].valueToCode(block, 'TIMEOUT_ID', Blockly['JavaScript'].ORDER_ATOMIC);
    return ` window.clearTimeout(${timerId}) \n`;
  };

  /**
   * Custom Blockly component to clear time interval
   */
  Blockly.Blocks['clear_time_interval'] = {
    init: function() {
      this.appendValueInput("TIMEOUT_ID")
        .setCheck(null)
        .appendField("Clear interval ");
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(290);
      this.setTooltip("");
      this.setHelpUrl("");
    }
  };

  Blockly['JavaScript']['clear_time_interval'] = function(block) {
    let timerId = Blockly['JavaScript'].valueToCode(block, 'TIMEOUT_ID', Blockly['JavaScript'].ORDER_ATOMIC);
    return ` window.clearInterval(${timerId}) \n`;
  };

  /**
   * Custom date difference in days block
   */
  Blockly.Blocks['custom-date-diff'] = {
    init: function() {
      this.appendDummyInput()
        .appendField("Get Date Difference: Date1 ")
        .appendField(new Blockly.FieldDropdown(DateControlNameOptions), "DATE1")
        .appendField("Date2 ")
        .appendField(new Blockly.FieldDropdown(DateControlNameOptions), "DATE2");
      this.setOutput(true, null);
      this.setColour(290);
      this.setTooltip("Get date difference in days");
      this.setHelpUrl("");
    }
  };

  Blockly['JavaScript']['custom-date-diff'] = function(block) {
    let datecontrolName1 = block.getFieldValue('DATE1');
    let datecontrolName2 = block.getFieldValue('DATE2');
    let code = ` window.getDateDifference && window.getDateDifference('DateDataFieldName####${datecontrolName1}####', 'DateDataFieldName####${datecontrolName2}####') `;
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };

    // DateTime Difference 

  Blockly.Blocks['custom-date-time-diff'] = {
    init: function () {
      this.appendDummyInput()
        .appendField("Get Date Time Difference: Date Time1 ")
        .appendField(new Blockly.FieldDropdown(DateTimeControlOptions), "DATETIME1")
        .appendField("Date Time2 ")
        .appendField(new Blockly.FieldDropdown(DateTimeControlOptions), "DATETIME2")
        .appendField("Time Format ")
        .appendField(new Blockly.FieldDropdown(DateTimeFormatOptions), "DATETIMEFORMAT");
      this.setOutput(true, null);
      this.setColour(290);
      this.setTooltip("Get date time difference in HH:MM or HH");
      this.setHelpUrl("");
    }
  };
  
  Blockly['JavaScript']['custom-date-time-diff'] = function (block) {  
    let datetimecontrolName1 = block.getFieldValue('DATETIME1');  
    let datetimecontrolName2 = block.getFieldValue('DATETIME2');  
    let dateTimeFormat = block.getFieldValue('DATETIMEFORMAT');
    let code = ` window.getDateTimeDifference && window.getDateTimeDifference('DateDataFieldName####${datetimecontrolName1}####', 'DateDataFieldName####${datetimecontrolName2}####', 'TimeFormat####${dateTimeFormat}####') `;
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };

  Blockly.Blocks['custom-date-add-subtract'] = {
    init: function() {
      this.appendValueInput("DAYS")
        .setCheck(null)
        .appendField("Add / Subtract Days: Date")
        .appendField(new Blockly.FieldDropdown(DateControlNameOptions), "CONTROL_NAME")
        .appendField(new Blockly.FieldDropdown([["+","ADD"], ["-","SUBTRACT"]]), "OPERATOR")
        .appendField(" No of days");
      this.setInputsInline(true);
      this.setOutput(true, null);
      this.setColour(290);
      this.setTooltip("Add / Subtract days to a date to derive a new date. Please make sure you have enter valid integer numbers in days.");
      this.setHelpUrl("");
    }
  };

  Blockly['JavaScript']['custom-date-add-subtract'] = function(block) {
    let date = block.getFieldValue('CONTROL_NAME');
    let operator = block.getFieldValue('OPERATOR');
    let days = Blockly['JavaScript'].valueToCode(block, 'DAYS', Blockly['JavaScript'].ORDER_ATOMIC);
    let code = ` window.addOrSubtractDate && window.addOrSubtractDate('${date}', '${operator}', ${days}) `;
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };

  /*
   * Custom block to get System Field value
   */
  Blockly.Blocks['sp_value_getter'] = {
    init: function() {
      this.appendDummyInput("CUSTOM_SP_VALUE_COMPARATOR_DUMMY_INPUT")
          .appendField("Get System Field Value: ")
          .appendField(new Blockly.FieldDropdown(SystemFieldNameOptions), "SP_NAME");
      this.setInputsInline(true);
      this.setOutput(true);
      this.setColour(290);
      this.setTooltip("Get system field value");
      this.setHelpUrl("");
    }
  };

  Blockly['JavaScript']['sp_value_getter'] = function(block) {
    let sp_name = block.getFieldValue('SP_NAME');
    let code = ` window.getSystemFieldValue && window.getSystemFieldValue('${sp_name}') `;
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };

  // sp user details
  Blockly.Blocks['sp_user_details_getter'] = {
    init: function () {
      this.appendDummyInput("Get User Details")
        .appendField("Get User Details: ")
        .appendField(new Blockly.FieldDropdown(spUserDetailsOptions), "USER_DETAIL_OPTION");
      this.setInputsInline(true);
      this.setOutput(true);
      this.setColour(290);
      this.setTooltip("Get User Details");
      this.setHelpUrl("");
    }
  };
  Blockly['JavaScript']['sp_user_details_getter'] = function (block) {
    let selectedOption = block.getFieldValue('USER_DETAIL_OPTION');
    let code = ` window.getUserDetailsFromSelectedOption && window.getUserDetailsFromSelectedOption('DS_USERDETAILS_FILTERED', '${selectedOption}') `;
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };

  /*
   * Custom block to get Current Date and Time
   */
  Blockly.Blocks['cur_datetime_value_getter'] = {
    init: function() {
      this.appendDummyInput("CUSTOM_TIME_VALUE_DUMMY_INPUT")
          .appendField("Get Current Date/Time:")
          .appendField(new Blockly.FieldDropdown(CurrentDateFieldOptions,this.validateFormatType), "DATE_TYPE");
      this.setInputsInline(true);
      this.setOutput(true);
      this.setColour(290);
      this.setTooltip("Get Current Date/Time");
      this.setHelpUrl("");
    },
    validateFormatType: function(formatType) {
      let block = this.getSourceBlock();
      let oldFormatType = block.formatType;
      block.formatType = formatType;
      if(!oldFormatType) {
        block.appendPropertyValueField(formatType);
      } else {
        setTimeout(() => {
          block.appendPropertyValueField(formatType);
        }, 50);
      }
      return formatType;
    },
    appendPropertyValueField: function(formatType) {
      let input = this.getInput('CUSTOM_TIME_VALUE_DUMMY_INPUT');
      input.removeField("SHOW_MERIDIAN" ,true);
      input.removeField("MERIDIAN_VALUE",true);
      if(!formatType) {
        return;
      }
      let type = formatType || '';
      if(type != 'date') {
        input.appendField("Show Meridian", 'SHOW_MERIDIAN');
        input.appendField(new Blockly.FieldCheckbox(true), 'MERIDIAN_VALUE');
        return;
      }
    }
  };

  Blockly['JavaScript']['cur_datetime_value_getter'] = function(block) {
    let dateType = block.getFieldValue('DATE_TYPE');
    let showMeridian = block.getFieldValue('MERIDIAN_VALUE');
    let code = ` window.getCurrentDateTime && window.getCurrentDateTime('${dateType}', '${showMeridian}') `;
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };

  
  /**
   * Custom block to compate System Field value
   */
  Blockly.Blocks['sp_value_comparator'] = {
    init: function() {
      this.appendDummyInput("CUSTOM_SP_VALUE_COMPARATOR_DUMMY_INPUT")
          .appendField("Compare System Field Value: ")
          .appendField(new Blockly.FieldDropdown(SystemFieldNameOptions, this.validateSystemFieldName), "SP_NAME")
          .appendField(new Blockly.FieldDropdown([["==","=="], ["!=","!="]]), "COMPARATOR_NAME")
          .appendField(new Blockly.FieldTextInput(""), "SP_VALUE");
      this.setInputsInline(true);
      this.setOutput(true, "Boolean");
      this.setColour(290);
      this.setTooltip("Compare system field value");
      this.setHelpUrl("");
    },

    validateSystemFieldName: function(systemFieldName) {
      let block = this.getSourceBlock();
      if(block.systemFieldName != systemFieldName) {
        let oldSystemFieldName = block.systemFieldName;
        block.systemFieldName = systemFieldName;
        if(!oldSystemFieldName) {
          block.onControlNameChanged(systemFieldName);
        } else {
          setTimeout(() => {
            block.onControlNameChanged(systemFieldName);
          }, 50);
        }
      }
      return systemFieldName;
    },

    onControlNameChanged: function(systemFieldName) {
      let input = this.getInput('CUSTOM_SP_VALUE_COMPARATOR_DUMMY_INPUT');
      if(!systemFieldName) {
        input.removeField('LOADING', true);
        input.removeField('SP_VALUE', true);
        input.removeField('SP_VALUE_MONTH', true);
        input.removeField('SP_VALUE_YEAR', true);
        input.removeField('DATE', true);
        input.removeField('MONTH', true);
        input.removeField('YEAR', true);
        input.removeField('CONFIRM_LABEL', true);
        return;
      }

      let newSystemFieldType = allSystemFieldsDataType[systemFieldName];
      if(this.prevSystemFieldType == newSystemFieldType) {
        return;
      }

      input.removeField('SP_VALUE', true);
      input.removeField('COMPARATOR_NAME', true);
      if(this.prevSystemFieldType == 'DATE') {
        input.removeField('SP_VALUE_MONTH', true);
        input.removeField('SP_VALUE_YEAR', true);
        input.removeField('DATE', true);
        input.removeField('MONTH', true);
        input.removeField('YEAR', true);
      }else if(this.prevSystemFieldType == 'BOOLEAN') {
        input.removeField('CONFIRM_LABEL', true);
      }

      this.prevSystemFieldType = newSystemFieldType;

      if (newSystemFieldType == 'DATE') {
        input.appendField(new Blockly.FieldDropdown([["==","=="], ["!=","!="], ["<","<"], ["<=","<="], [">",">"], [">=",">="]]), "COMPARATOR_NAME");
      }else {
        input.appendField(new Blockly.FieldDropdown([["==","=="], ["!=","!="]]), "COMPARATOR_NAME");
      }

      if (newSystemFieldType == 'DATE') {
        let date = new Date();
        input.appendField(" Date", 'DATE');
        input.appendField(new Blockly.FieldNumber(date.getDate(), 0, 31, 1), "SP_VALUE");
        input.appendField("Month", 'MONTH');
        input.appendField(new Blockly.FieldNumber(date.getMonth() + 1, 1, 12, 1), "SP_VALUE_MONTH");
        input.appendField("Year", 'YEAR');
        input.appendField(new Blockly.FieldNumber(date.getFullYear(), 1970, 9999, 1), "SP_VALUE_YEAR");
      } else if (newSystemFieldType == 'BOOLEAN') {
        input.appendField(new Blockly.FieldCheckbox(true), "SP_VALUE");
        input.appendField("Yes", 'CONFIRM_LABEL');
      } else {
        input.appendField(new Blockly.FieldTextInput(""), "SP_VALUE");
      }

    }
  };
  
  Blockly['JavaScript']['sp_value_comparator'] = function(block) {
    let sp_name = block.getFieldValue('SP_NAME');
    let comparator_name = block.getFieldValue('COMPARATOR_NAME');
    let sp_value = block.getFieldValue('SP_VALUE');
    if(this.prevSystemFieldType == 'DATE') {
      sp_value = block.getFieldValue('SP_VALUE_YEAR') + '-' + block.getFieldValue('SP_VALUE_MONTH') + '-' + sp_value;
    }
    let code = ` window.compareSystemFieldValue && window.compareSystemFieldValue("${sp_name}", "${comparator_name}", "${sp_value}", "${this.prevSystemFieldType}") `;
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };


  Blockly.Blocks['auto_next_number_block'] = {
    init: function() {
      this.appendDummyInput('CUSTOM_AUTO_NEXT_NUMBER_DUMMY_INPUT')
        .appendField("Auto Numbering: ")
        .appendField(new Blockly.FieldDropdown(AutoNumberControlNameOptions), "AUTO_NUMBER_FIELD")
        .appendField("Length: ")
        .appendField(new Blockly.FieldNumber(3, 1, 25, 1, this.autoNumbeLengthChanged), "AUTO_NUMBER_LENGTH")
        .appendField("Start: ")
        .appendField(new Blockly.FieldTextInput('000', this.validateStartFrom), "AUTO_NUMBER_START_FROM")
        .appendField("Position: ")
        .appendField(new Blockly.FieldDropdown([["Suffix","POSTFIX"]]), "AUTO_NUMBER_POSITION")
        .appendField("Separator: ")
        .appendField(new Blockly.FieldDropdown([["-","-"]]), "AUTO_NUMBER_SEPARATOR")
        .appendField("String Check: ")
        .appendField(new Blockly.FieldDropdown([["YES", "YES"],["NO", "NO"] ]), "AUTO_NUMBER_STRINGCHECK")
        .appendField("AutoNumbering")
        .appendField(new Blockly.FieldDropdown([["YES", "YES"], ["NO", "NO"]]), "EXECUTE_AUTO_NUMBER")
        .appendField(" Value");
      this.appendValueInput("AUTO_NUMBER_TITLE")
        .setCheck(null);
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(290);
      this.setTooltip("Set auto numbering on slected data field name control.");
      this.setHelpUrl("");
    },

    autoNumbeLengthChanged(autoNumberLength) {
      let block = this.getSourceBlock();
      if(block) {
        let input = block.getInput('CUSTOM_AUTO_NEXT_NUMBER_DUMMY_INPUT');
        input.removeField('AUTO_NUMBER_START_FROM', true);
        let startFromVal = '';
        for(let i = 0; i < autoNumberLength; i++) {
          startFromVal += '0';
        }
        input.insertFieldAt(5, new Blockly.FieldTextInput(startFromVal, block.validateStartFrom), "AUTO_NUMBER_START_FROM");
      }
    },
    
    validateStartFrom(newValue) {
      if(newValue.indexOf(".") != -1 || newValue.indexOf("+") != -1 || newValue.indexOf("-") != -1 || isNaN(+newValue)) {
        return null;
      }

      let block = this.getSourceBlock();
      let seqLength = block.getFieldValue('AUTO_NUMBER_LENGTH');
      if(seqLength != newValue.length) {
        return null;
      }
      return newValue;
    },

    /* validateSeparator: function(newValue) {
      if (newValue.indexOf("'") != -1 || newValue.indexOf('"') != -1  || newValue.indexOf('`') != -1 || newValue.indexOf('{') != -1 || newValue.indexOf('}') != -1 ||
        newValue.indexOf('[') != -1 || newValue.indexOf(']') != -1  || newValue.indexOf('<') != -1 || newValue.indexOf('>') != -1 || newValue.indexOf("\\") != -1 ||
        newValue.indexOf('(') != -1 || newValue.indexOf(")") != -1 || newValue.indexOf("/") != -1) {
        return null;
      }
      return newValue;
    } */
  };
  
  Blockly['JavaScript']['auto_next_number_block'] = function(block) {
    let autoNumberField = block.getFieldValue('AUTO_NUMBER_FIELD');
    let autoNumberLength = block.getFieldValue('AUTO_NUMBER_LENGTH');
    let autoNumberStartFrom = +(block.getFieldValue('AUTO_NUMBER_START_FROM'));
    let autoNumberPosition = block.getFieldValue('AUTO_NUMBER_POSITION');
    let autoNumberSeparator = block.getFieldValue('AUTO_NUMBER_SEPARATOR');
    let autoNumberStringCheck = block.getFieldValue('AUTO_NUMBER_STRINGCHECK');
    let isAutoNumbering = block.getFieldValue('EXECUTE_AUTO_NUMBER');
    let autoNumberTitle = Blockly['JavaScript'].valueToCode(block, 'AUTO_NUMBER_TITLE', Blockly['JavaScript'].ORDER_ATOMIC) || 'null';
    let code = ` window.setAutoNumbering && window.setAutoNumbering('${autoNumberField}', ${autoNumberLength}, ${autoNumberStartFrom - 1}, '${autoNumberPosition}', '${autoNumberSeparator}', '${autoNumberStringCheck}', ${autoNumberTitle}, '${isAutoNumbering}'); \n `;
    return code;
  };

  /**
  * suffix block for autonumbering
  */
    Blockly.Blocks['auto_next_number_suffix_block'] = {
      init: function () {  
        this.appendDummyInput('CUSTOM_AUTO_NEXT_NUMBER_DUMMY_INPUT')
          .appendField("Advance Auto-Numbering")
          .appendField(new Blockly.FieldDropdown(AutoNumberControlNameOptions), "AUTO_NUMBER_FIELD")
          .appendField("Length: ")
          .appendField(new Blockly.FieldNumber(3, 1, 25, 1, this.autoNumbeLengthChanged), "AUTO_NUMBER_LENGTH")
          .appendField("Start: ")
          .appendField(new Blockly.FieldTextInput('000', this.validateStartFrom), "AUTO_NUMBER_START_FROM")
          .appendField("Position: ")
          .appendField(new Blockly.FieldDropdown([["Suffix", "POSTFIX"]]), "AUTO_NUMBER_POSITION")
          .appendField("Separator: ")
          .appendField(new Blockly.FieldDropdown([["-", "-"]]), "AUTO_NUMBER_SEPARATOR")
          .appendField("String Check: ")
          .appendField(new Blockly.FieldDropdown([["YES", "YES"], ["NO", "NO"]]), "AUTO_NUMBER_STRINGCHECK")
          .appendField("AutoNumbering")
          .appendField(new Blockly.FieldDropdown([["YES", "YES"], ["NO", "NO"]]), "EXECUTE_AUTO_NUMBER")
          .appendField("Value");
        this.appendValueInput("AUTO_NUMBER_TITLE")
        this.appendDummyInput(null)
          .appendField("AutoNumber Generator: ");
        this.appendValueInput("GENERATE_NUMBER")
        this.appendDummyInput(null)
          .appendField("Suffix: ");
        this.appendValueInput("SUFFIX_VALUE")
          .setCheck(null);
        this.setInputsInline(true);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(290);
        this.setTooltip("Set auto numbering on slected data field name control.");
        this.setHelpUrl("");
      },

  

      autoNumbeLengthChanged(autoNumberLength) {
        let block = this.getSourceBlock();
        if (block) {
          let input = block.getInput('CUSTOM_AUTO_NEXT_NUMBER_DUMMY_INPUT');
          input.removeField('AUTO_NUMBER_START_FROM', true);
          let startFromVal = '';
          for (let i = 0; i < autoNumberLength; i++) {
            startFromVal += '0';
          }
          input.insertFieldAt(5, new Blockly.FieldTextInput(startFromVal, block.validateStartFrom), "AUTO_NUMBER_START_FROM");
        }
      },

      validateStartFrom(newValue) {
        if (newValue.indexOf(".") != -1 || newValue.indexOf("+") != -1 || newValue.indexOf("-") != -1 || isNaN(+newValue)) {
          return null;
        }
  
        let block = this.getSourceBlock();
        let seqLength = block.getFieldValue('AUTO_NUMBER_LENGTH');
        if (seqLength != newValue.length) {
          return null;
        }
        return newValue;
      },
    };

    Blockly['JavaScript']['auto_next_number_suffix_block'] = function (block) {
      let autoNumberField = block.getFieldValue('AUTO_NUMBER_FIELD');
      let autoNumberLength = block.getFieldValue('AUTO_NUMBER_LENGTH');
      let autoNumberStartFrom = +(block.getFieldValue('AUTO_NUMBER_START_FROM'));
      let autoNumberPosition = block.getFieldValue('AUTO_NUMBER_POSITION');
      let autoNumberSeparator = block.getFieldValue('AUTO_NUMBER_SEPARATOR');
      let autoNumberStringCheck = block.getFieldValue('AUTO_NUMBER_STRINGCHECK');
      let isAutoNumbering = block.getFieldValue('EXECUTE_AUTO_NUMBER');
      let autoNumberTitle = Blockly['JavaScript'].valueToCode(block, 'AUTO_NUMBER_TITLE', Blockly['JavaScript'].ORDER_ATOMIC) || 'null';
      let suffix = Blockly['JavaScript'].valueToCode(block, 'GENERATE_NUMBER', Blockly['JavaScript'].ORDER_ATOMIC) || 'null';
      let postfix = Blockly['JavaScript'].valueToCode(block, 'SUFFIX_VALUE', Blockly['JavaScript'].ORDER_ATOMIC) || 'null';
      let code = ` window.setAutoNumberingSuffix && window.setAutoNumberingSuffix('${autoNumberField}', ${autoNumberLength}, ${autoNumberStartFrom - 1}, '${autoNumberPosition}', '${autoNumberSeparator}', '${autoNumberStringCheck}', ${autoNumberTitle}, '${isAutoNumbering}', ${suffix}, ${postfix} ); \n `;
      return code;
    };


  /**
   * Custom block to fix floating point value
   */
   Blockly.Blocks['custom_math_to_fixed'] = {
    init: function() {
      this.appendValueInput("TO_FIXED_INPUT")
        .setCheck(null)
        .appendField("toFixed by ")
        .appendField(new Blockly.FieldNumber(2, 0, 10, 1), "TO_FIXED_NUMBER")
        .appendField(" ");
      this.setInputsInline(true);
      this.setOutput(true, null);
      this.setColour(230);
      this.setTooltip("It is rounding the number to keep only passed number of decimals");
      this.setHelpUrl("");
    }
  };

  Blockly['JavaScript']['custom_math_to_fixed'] = function(block) {
    let fixedNumberVaue = block.getFieldValue('TO_FIXED_NUMBER');
    let value = Blockly['JavaScript'].valueToCode(block, 'TO_FIXED_INPUT', Blockly['JavaScript'].ORDER_ATOMIC);
    let code = ` isNaN(parseFloat(${value})) ? '' : (+${value}).toFixed(${fixedNumberVaue}) `;
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };


  /**
   * Custom repeating table value getter
   */
  Blockly.Blocks['custom-get-repeating-table-rows'] = {
    init: function() {
      this.appendDummyInput("CUSTOM_GET_REPEATING_TABLE_ROWS")
          .appendField("Get Repeating Table Value :")
          .appendField(new Blockly.FieldDropdown(RepeatingTableControlNameOptions, this.validateControlName), "CONTROL_NAME");
      this.setInputsInline(true);
      this.setOutput(true);
      this.setColour(120);
      this.setTooltip("Get repeating table value");
      this.setHelpUrl("");
    },
    validateControlName: function(controlName) {
      if(this.controlName != controlName) {
        let oldControlName = this.controlName;
        this.controlName = controlName;
        if(!oldControlName) {
          this.getSourceBlock().updateConnections(controlName, oldControlName);
        } else {
          setTimeout(() => {
            this.getSourceBlock().updateConnections(controlName, oldControlName);
          }, 50);
        }
      }
      return controlName;
    },

    updateConnections: function(controlName, oldControlName) {
      refreshScopeInputField(this, oldControlName, controlName, customFields);
    }
  };

  Blockly['JavaScript']['custom-get-repeating-table-rows'] = function(block) {
    let ct_name = block.getFieldValue('CONTROL_NAME');
    let scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || '';
    let code = ` window.getRepeatingTableValue && window.getRepeatingTableValue('${ct_name}', ${scopeData}) `;
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };

  Blockly['JavaScript']['minmax_datevalue'] = function (block) {
    let minmax_datevalue = block.getFieldValue('minmax');
    let gVal = [];

    const elements = [];
    for (let i = 0; i < block.itemCount_; i++) {
      elements[i] = Blockly['JavaScript'].valueToCode(block, 'ADD' + i, Blockly['JavaScript'].ORDER_NONE) || 'null';
    }
    console.log(elements);

    for (let i = 0; i < elements.length; i++) {

      if (elements[i].indexOf('window.getPropValueByDataFieldName') != -1) {
        gVal.push(elements[i].split("'")[1]);
      } else {

        gVal.push('otherValue');

      }

    }

    let code = ` window.getMinmaxDateValue && window.getMinmaxDateValue('${minmax_datevalue}', '${gVal.join('##')}', ${elements})  `;
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };
  Blockly.Blocks['set_api_data'] = {

    init: function () {
      this.appendStatementInput("SET_API_DATA")
        .appendField("Select API ")
        .appendField(new Blockly.FieldDropdown(APINameOptions, this.validateAPIName), "API_NAME")
        .appendField(new Blockly.FieldVariable(null), "RESPONSE_DATA_VAR");
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(230);
      this.setTooltip("Get the API response");
      this.setHelpUrl("");
    },
    validateAPIName: function (apiName) {
      let block = this.getSourceBlock();
      let input = block.getInput('SET_API_DATA');
      if (block.apiName != apiName) {
        block.apiName = apiName;
        setTimeout(() => {
          if (block.apiName != "") {
            block.getApiConnectionData(block.apiName, block, input);
          }
        }, 500);
      }
      return apiName;
    },
    

    getApiConnectionData: function (apiname, block, input) {
      if (block.workspace) block.workspace['isAPIInProgress'] = true;
      var apiConnection = newOption.apiNames.find(obj => {
        return obj.name == apiname;
      });
      var myHeaders, queryString;
      if (apiConnection.externalApi) {
        let parameters = angular.copy(apiConnection.parameters);
        parameters.params = parameters.params.map(function(item){
          item.value = item.testValue;
          return item;
        });

        parameters.headers  = parameters.headers.map(function(item){
          item.value = item.testValue;
          return item;
        });
        
        parameters.bodyParams = parameters.bodyParams.map(function(item){
          item.value = item.testValue;
          return item;
        });
      

        let datas = Object.assign({}, apiConnection);
        datas.parameters = angular.copy(parameters);
        datas.url = datas.testUrl;
        let url = (<any>window).properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + 'apps?action_id=858&externalApi=true';

        let req = {
          'url': url,
          'method': 'POST',
          'withCredentials': true,
          data: JSON.stringify(datas),
        }
        
        newOption.$http(req).then(response => {
          if(block.workspace) block.workspace['isAPIInProgress'] = false;
          response = response.data || response;
          block['responseDataFromAPI'] = response;
          if (block.getField('RESPONSE_DATA_VAR') && block.getField('RESPONSE_DATA_VAR').getVariable()) {
            block.getField('RESPONSE_DATA_VAR').getVariable()['responseDataFromAPI'] = response;
          }
        }, error => {
          if(block.workspace) block.workspace['isAPIInProgress'] = false;
          console.log("err", error);
          return error;
        });

      } else {
        let currentProjectName = "";
        let findProject = projectsLists.filter((item) => {return item.id == currentProjectID});
        currentProjectName = findProject.length ? findProject[0].value : "";

        let selectedAsiteApiId = apiConnection.userSelectedAsiteApiId;
        let selectedApi = newOption.apiNames.find(function (item) {
          return item.asiteApiId == selectedAsiteApiId;
        });
        let queryString = '';

        let headers = apiConnection.parameters.filter(el => el.header == true);

        headers = headers.reduce(function (prev, curr) {
          if (curr.name !== '') {
            //prev[curr.name] = self.USP.aSessionId || '';
            return prev;
          }
        }, {});

        let data = apiConnection.parameters.filter(el => el.header == false);
        let operatorObject = {};

        // create object for the operator fiedname
        operatorObject = data.reduce(function (prev, curr) {
          if(curr.name!="isComingFormApiConnection"){
            if (curr.operator == 'IN')
              prev["operator_" + curr.name] = "CONTAINS";
            else if (curr.operator == 'NOT IN')
              prev["operator_" + curr.name] = "NOT_CONTAIN";
            else if (curr.operator == '!=')
              prev["operator_" + curr.name] = "NOT_EQUALS";
            else
              prev["operator_" + curr.name] = "EQUALS";
          }
          return prev;
        }, {});

        // create a object for the key value for pair from the array
        let queryObject = {};
        queryObject = data.reduce(function (prev, curr) {
          if (curr.name !== '') {
            if(curr.name == 'projectId'){
              prev[curr.name] = newOption.config.formID.projectId;
            }else if(curr.name == 'formTypeId'){
              prev[curr.name] = newOption.config.formID.formTypeId;
            }else if(curr.name == 'ProjectName'){
              prev[curr.name] = curr.testValue.replaceAll("{{Current Project}}",currentProjectName);
            }else
            prev[curr.name] = curr.testValue;
            return prev;
          }
        }, {});

        // create a query string from the obect to pass it to the api as queryparam
        const finalQueryObject = Object.assign({}, queryObject, operatorObject);
        if (finalQueryObject) {
          queryString = Object.keys(finalQueryObject)
            .map(name => `${encodeURIComponent(name)}=${encodeURIComponent(finalQueryObject[name])}`)
            .join('&');
        }
        
        // send hasOldDelimiter in app api call
        let isOldDelimiter = true;
        if(apiConnection.hasOwnProperty('hasOldDelimiter')){
          isOldDelimiter = apiConnection.hasOldDelimiter;
        }

        let internalAPiUrl = (<any>window).properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + 'apps?action_id=858&hasOldDelimiter='+isOldDelimiter;
        queryString = queryString + '&externalApi=false&apiUrl='+apiConnection.url;

        let req = {
          'url': queryString == '' ? internalAPiUrl : internalAPiUrl + '&' + queryString,
          'method': apiConnection.requestType,
          'withCredentials': true,
          'headers': (headers && Object.keys(headers).length === 0) ? {} : headers,
        }
        newOption.$http(req).then(response => {
          if(block.workspace) block.workspace['isAPIInProgress'] = false;
          response = response.data || response;
          block['responseDataFromAPI'] = response;
          if (block.getField('RESPONSE_DATA_VAR') && block.getField('RESPONSE_DATA_VAR').getVariable()) {
            block.getField('RESPONSE_DATA_VAR').getVariable()['responseDataFromAPI'] = response;
          }
        }, error => {
          if(block.workspace) block.workspace['isAPIInProgress'] = false;
        });
      }
    }
  };

  Blockly['JavaScript']['set_api_data'] = function (block) {
    let apiName = block.getFieldValue('API_NAME');
    let apiHandler = Blockly['JavaScript'].statementToCode(block, 'SET_API_DATA');
    let responseDataVar = Blockly['JavaScript'].variableDB_.getName(
      block.getFieldValue('RESPONSE_DATA_VAR'), Blockly.VARIABLE_CATEGORY_NAME);
    let code = `window.mergeDataFromAPI('${apiName}',
      function(responseData) {
        ${responseDataVar} = responseData;
        ${apiHandler}
      }
    );\n`
    return code;
  };

  Blockly.Blocks['location_association'] = {
    init: function () {
      this.appendStatementInput("LOCATION_ASSOCIATION")
        .appendField("Location Association ");
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(230);
      this.setTooltip("Use while associating location from Projects Tab");
      this.setHelpUrl("");
    },
  };

  Blockly['JavaScript']['location_association'] = function (block) {
    let logicHandler = Blockly['JavaScript'].statementToCode(block, 'LOCATION_ASSOCIATION');
    let code = `function locationAssociationCallback(){
      ${logicHandler}
    };\n`
    return code;
  };

  Blockly.Blocks['get-custom-response'] = {
    init: function () {
      this.appendValueInput('RESPONSE_DATA').setCheck(null).appendField("  API Data", "API_DATA_KEY")
      this.appendDummyInput("CUSTOM_RESPONSE")
        .appendField("Select field ")
        .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this), this.validateFieldOptions), "FIELD_NAME")
        .appendField(" Option Map ", 'SET_KEY')
        .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this), this.validateFieldOptionsMap), 'KEY_NAME')
      this.setInputsInline(true);
      this.setOutput(true);
      this.setColour(290);
      this.setTooltip("Fetch field data from API response");
      this.setHelpUrl("");
      this.jsonInit({ "mutator": "dropdown_mutator" });
    },

    generateOptions: function () {
      let responseDataOptions1 = [['Please select', 'Please select']];
      let block = this;
      if (block && block.childBlocks_ && block.childBlocks_[0] && block.childBlocks_[0].getVarModels()[0] && block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']) {
        let options = block.recursionOnResponseData(responseDataOptions1, block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']);
        return options;
      } else {
        if (block && block.type == 'get-custom-response' && block.parentBlock_) {
          var apiBLock = block.findAPIBlock(block.parentBlock_);
          if (apiBLock && apiBLock.responseDataFromAPI) {
            let options = block.recursionOnResponseData(responseDataOptions1, apiBLock.responseDataFromAPI);
            return options;
          }
        }
      }
      return responseDataOptions1;
    },
    findAPIBlock: function (block) {
      if (block && block.type == 'set_api_data') {
        return block;
      } else {
        if(block)
        return this.findAPIBlock(block.parentBlock_);
      }
    },

    recursionOnResponseData: function (arr, responseData, parentkey, parentArrPathKey) {
      if(responseData.length > 0) {
        responseData = responseData[0];
      }
      for (var key in responseData) {

        if (responseData.hasOwnProperty(key)) {
          var elemVal = responseData[key];
          if ((elemVal == null) ||(typeof (elemVal) != 'object')) {
            if (parentkey) {
              arr.push([parentkey + '.' + key, parentkey + '.' + key])
            } else if (parentArrPathKey) {
              let keyPath = parentArrPathKey + '["' + key + '"]';
              arr.push([keyPath, key]);
            } else {
              arr.push([key, key]);
            }
          } else if (elemVal != null && typeof (elemVal) == 'object' && elemVal.length > 0) {
            let parentkeynew = parentkey ? parentkey + '.' + key : key;
            arr.push([parentkeynew, parentkeynew]);
            this.recursionOnResponseData(arr, elemVal[0], '', parentkeynew);
          } else {
            let parentkeynew = parentkey ? parentkey + '.' + key : key;
            this.recursionOnResponseData(arr, elemVal, parentkeynew);
          }
        }
      }
      return arr;
    },
    validateFieldOptions: function (fieldName) {
      let block = this.getSourceBlock();
      if (this.fieldName != fieldName) {
        let oldfieldName = this.fieldName;
        this.fieldName = fieldName;
        if (!oldfieldName) {
          this.getSourceBlock().onFieldNameChanged(block);
        } else {
          setTimeout(() => {
            this.getSourceBlock().onFieldNameChanged(block);
          }, 500);
        }
      }
      return fieldName;
    },

    validateFieldOptionsMap: function(fieldName) {
      let block = this.getSourceBlock();
      if(block.getFieldValue('FIELD_NAME') === 'Please select') {
        return block.getFieldValue('FIELD_NAME');
      }
      return fieldName;
    },
    
    onFieldNameChanged: function (block) {
      refreshDropdownInputField(block);
    },
  }

  Blockly['JavaScript']['get-custom-response'] = function (block) {
    let ct_name = block.getFieldValue('FIELD_NAME');
    let optionMap = block.getFieldValue('KEY_NAME');
    let responseData = Blockly['JavaScript'].valueToCode(block, 'RESPONSE_DATA', Blockly['JavaScript'].ORDER_NONE) || 'null';
    let code = `window.getCustomResponse && window.getCustomResponse('${ct_name}',${responseData}, '${optionMap}')\n `;
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };

  Blockly['JavaScript']['custom_dropdownoptions'] = function (block) {
    let custom_dropdownoptions = block.getFieldValue('DROPDOWN_OPTIONS');
    let separator_val = block.getFieldValue('OPTION_SEPARATOR');
    let gVal = [];

    const elements = [];
    for (let i = 0; i < block.itemCount_; i++) {
      elements[i] = Blockly['JavaScript'].valueToCode(block, 'ADD' + i, Blockly['JavaScript'].ORDER_NONE) || 'null';
    }
    console.log(elements);

    for (let i = 0; i < elements.length; i++) {
      gVal.push(elements[i]);
    }

    let code = `(window.getCustomDropdownOptions && window.getCustomDropdownOptions(responseData,'${custom_dropdownoptions}', '${separator_val}', "${gVal.join('##')}"))\n `;
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };

  Blockly.Blocks['custom_dropdown'] = {
    init: function () {
      this.appendDummyInput("CUSTOM_DROPDOWN")
        .appendField("Select field ")
        .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this), this.validateFieldOptions), "FIELD_NAME")
      this.setInputsInline(true);
      this.setOutput(true);
      this.setColour(290);
      this.setTooltip("Get filtered fields");
      this.setHelpUrl("");
      this.jsonInit({ "mutator": "dropdown_mutator" });
    },

    generateOptions: function () {
      let responseDataOptions1 = [['Please select', '']];
      let block = this, selectedCollection;
      if (block && block.type == 'custom_dropdown' && block.parentBlock_) {
        if(block.parentBlock_ && block.parentBlock_.type == 'custom_dropdownoptions') {
          var multipleoptiondropdownBLock = block.parentBlock_;
           selectedCollection = multipleoptiondropdownBLock.getFieldValue('DROPDOWN_OPTIONS');
        }
        var apiBLock = block.findAPIBlock(block.parentBlock_);
        if (apiBLock && apiBLock.responseDataFromAPI) {
          let filteredData = block.deepFind(apiBLock.responseDataFromAPI,selectedCollection);
          let options = block.recursionOnResponseData(responseDataOptions1, filteredData);
          return options;
        }
      }
      return responseDataOptions1;
    },
    deepFind:function (obj,path) {
      var current = '';
      if (obj && path) {
          var paths = path.split('.')
              , i;
          current = obj;
          for (i = 0; i < paths.length; ++i) {
              if (current[paths[i]] == undefined) {
                  return undefined;
              } else {
                  current = current[paths[i]];
              }
          }
      }
      return current;
    },
    findAPIBlock: function (block) {
      if (block && block.type == 'set_api_data') {
        return block;
      } else {
        if(block)
        return this.findAPIBlock(block.parentBlock_);
      }
    },

    recursionOnResponseData: function (arr, responseData, parentkey, parentArrPathKey) {
      if(responseData.length > 0) {
        responseData = responseData[0];
      }
      for (var key in responseData) {

        if (responseData.hasOwnProperty(key)) {
          var elemVal = responseData[key];
          if ((elemVal == null) ||(typeof (elemVal) != 'object')) {
            if (parentkey) {
              arr.push([parentkey + '.' + key, parentkey + '.' + key])
            } else if (parentArrPathKey) {
              let keyPath = parentArrPathKey + '["' + key + '"]';
              arr.push([keyPath, key]);
            } else {
              arr.push([key, key]);
            }
          } else if (elemVal != null && typeof (elemVal) == 'object' && elemVal.length > 0) {
            let parentkeynew = parentkey ? parentkey + '.' + key : key;
            arr.push([parentkeynew, parentkeynew]);
            this.recursionOnResponseData(arr, elemVal[0], '', parentkeynew);
          } else {
            let parentkeynew = parentkey ? parentkey + '.' + key : key;
            this.recursionOnResponseData(arr, elemVal, parentkeynew);
          }
        }
      }
      return arr;
    },
    validateFieldOptions: function (fieldName) {
      if (this.fieldName != fieldName) {
        this.fieldName = fieldName;
      }
      return fieldName;
    },
  }

  Blockly['JavaScript']['custom_dropdown'] = function (block) {
    let ct_name = block.getFieldValue('FIELD_NAME');
    return [ct_name, Blockly['JavaScript'].ORDER_ATOMIC];;
  }

  Blockly.Blocks['custom-getter-from-api-for-repeating-table'] = {
    init: function () {
      this.appendDummyInput("CUSTOM_REPEATING_RESPONSE")
        .appendField("Select field ")
        .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this), this.validateFieldOptions), "COLLECTION_NAME")
        .appendField("Option Map ", 'R_KEY_LABEL')
        .appendField(new Blockly.FieldDropdown(this.generateOptionsForFilteredData.bind(this)), 'R_KEY_NAME')
      this.appendValueInput('INDEX_DATA').setCheck(null).appendField("Index at", "ROW_INDEX")
      
      this.setInputsInline(true);
      this.setOutput(true);
      this.setColour(290);
      this.setTooltip("Fetch data from API response from collection");
      this.setHelpUrl("");
      this.jsonInit({ "mutator": "dropdown_mutator" });
    },

    generateOptions: function () {
      let responseDataOptions1 = [['Please select', '']];
      let block = this;
      if (block && block.childBlocks_ && block.childBlocks_[0] && block.childBlocks_[0].getVarModels()[0] && block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']) {
        let options = block.recursionOnResponseData(responseDataOptions1, block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']);
        return options;
      } else {
        if (block && block.type == 'custom-getter-from-api-for-repeating-table' && block.parentBlock_) {
          var apiBLock = block.findAPIBlock(block.parentBlock_);
          if (apiBLock && apiBLock.responseDataFromAPI) {
            let options = block.recursionOnResponseData(responseDataOptions1, apiBLock.responseDataFromAPI);
            return options;
          }
        }
      }
      return responseDataOptions1;
    },
    generateOptionsForFilteredData: function () {
      let responseDataOptions1 = [['Please select', '']];
      let block = this, selectedCollection;
      if (block && block.parentBlock_ && block.getFieldValue('COLLECTION_NAME')) {
        selectedCollection = block.getFieldValue('COLLECTION_NAME');
        var apiBlock = block.findAPIBlock(block.parentBlock_);
        if (apiBlock && apiBlock.responseDataFromAPI) {
          let filteredData = block.deepFind(apiBlock.responseDataFromAPI,selectedCollection);
          let options = block.recursionOnResponseData(responseDataOptions1, filteredData);
          return options;
        }
      }
      return responseDataOptions1;
    },
    deepFind:function (obj,path) {
      var current = '';
      if (obj && path) {
          var paths = path.split('.')
              , i;
          current = obj;
          for (i = 0; i < paths.length; ++i) {
              if (current[paths[i]] == undefined) {
                  return undefined;
              } else {
                  current = current[paths[i]];
              }
          }
      }
      return current;
    },
    findAPIBlock: function (block) {
      if (block && block.type == 'set_api_data') {
        return block;
      } else {
        if(block)
        return this.findAPIBlock(block.parentBlock_);
      }
    },

    recursionOnResponseData: function (arr, responseData, parentkey, parentArrPathKey) {
      if(responseData.length > 0) {
        responseData = responseData[0];
      }
      for (var key in responseData) {

        if (responseData.hasOwnProperty(key)) {
          var elemVal = responseData[key];
          if ((elemVal == null) ||(typeof (elemVal) != 'object')) {
            if (parentkey) {
              arr.push([parentkey + '.' + key, parentkey + '.' + key])
            } else if (parentArrPathKey) {
              let keyPath = parentArrPathKey + '["' + key + '"]';
              arr.push([keyPath, key]);
            } else {
              arr.push([key, key]);
            }
          } else if (elemVal != null && typeof (elemVal) == 'object' && elemVal.length > 0) {
            let parentkeynew = parentkey ? parentkey + '.' + key : key;
            arr.push([parentkeynew, parentkeynew]);
            this.recursionOnResponseData(arr, elemVal[0], '', parentkeynew);
          } else {
            let parentkeynew = parentkey ? parentkey + '.' + key : key;
            this.recursionOnResponseData(arr, elemVal, parentkeynew);
          }
        }
      }
      return arr;
    },
    validateFieldOptions: function (fieldName) {
      if (this.fieldName != fieldName) {
        this.fieldName = fieldName;
      }
      return fieldName;
    },
  }

  Blockly['JavaScript']['custom-getter-from-api-for-repeating-table'] = function (block) {
    let ct_name = block.getFieldValue('COLLECTION_NAME');
    let optionMap = block.getFieldValue('R_KEY_NAME');
    let indexAt = Blockly['JavaScript'].valueToCode(block, 'INDEX_DATA', Blockly['JavaScript'].ORDER_NONE) || 'null';
    let code = `window.getCustomResponseForRepeatingTable && window.getCustomResponseForRepeatingTable(responseData,'${ct_name}',${indexAt}, '${optionMap}') \n `;
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };
  
  /**
   * Auto inserting row in repeating table block
   */
   Blockly.Blocks['repeating-table-functionality'] = {
    init: function () {
      this.appendDummyInput('REPEATING_TABLE_FUNCTIONALITY')
        .appendField("Set Repeating Table Functionality : ")
        .appendField(new Blockly.FieldDropdown(functionalityOptions, this.validateFunctionOption), "FUNCTIONALITY")
        .appendField(" Control Name :")
        .appendField(new Blockly.FieldDropdown(RepeatingTableControlNameOptions, this.validateControlName), 'CONTROL_NAME')
      // .appendField(new Blockly.FieldDropdown(AutoHasIndexOptions, this.validateNumber), "IndexValue")
      // this.appendValueInput('ROW_DATA').setCheck(null);
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(120);
      this.setTooltip("repeating table functionality.");
      this.setHelpUrl("");
    },

    validateFunctionOption: function (controlName) {
      if (this.controlName != controlName) {
        let oldControlName = this.controlName;
        this.controlName = controlName;
        if (!oldControlName) {
          this.getSourceBlock().onFunctionalityChange(controlName);
        } else {
          setTimeout(() => {
            this.getSourceBlock().onFunctionalityChange(controlName);
          }, 50);
        }
      }
      return controlName;
    },

    onFunctionalityChange: function (controlName) {
      let input = this.getInput('REPEATING_TABLE_FUNCTIONALITY');
      input.removeField('VALUE_CHECKBOX', true);
      input.removeField('READONLY_CHECKBOX', true);
      if (controlName != "insertRow") {
        input.removeField('INDEX_VALUE', true);
        input.appendField(new Blockly.FieldDropdown(AutoHasIndexOptionUpdate, this.validateIndexNumber), "INDEX_VALUE");
      } if (controlName == "insertRow") {
        input.removeField('INDEX_VALUE', true);
        input.appendField(new Blockly.FieldDropdown(AutoHasIndexOptions, this.validateIndexNumber), "INDEX_VALUE");
      } if (controlName == "showRow") {
        input.appendField(new Blockly.FieldCheckbox(true), 'VALUE_CHECKBOX');
      }if (controlName == "readOnly") {
        input.appendField(new Blockly.FieldCheckbox(true), 'READONLY_CHECKBOX');
      }
    },

    validateIndexNumber: function (controlName) {
      if (this.controlName != controlName) {
        let oldControlName = this.controlName;
        this.controlName = controlName;
        if (!oldControlName) {
          this.getSourceBlock().onIndexChange(controlName);
        } else {
          setTimeout(() => {
            this.getSourceBlock().onIndexChange(controlName);
          }, 50);
        }
      }
      return controlName;
    },

    onIndexChange: function (controlName) {
      let input = this.getInput('REPEATING_TABLE_FUNCTIONALITY')
      if (controlName != "allRow") {
        this.removeInput("ROW_DATA", true);
        this.removeInput('SCOPE_DATA', true);
        this.appendValueInput("ROW_DATA").setCheck(null);
        // if(this.getInput('SCOPE_DATA', true)){
        // }
        let inp = this.getFieldValue('CONTROL_NAME');
        if (isRepeatingTableControl(inp, customFields)) {
          this.appendValueInput('SCOPE_DATA').appendField("   Scope: ", 'SCOPE');
        }
        // this.setShadowDom("ROW_DATA");
      }
      if (controlName == "allRow") {
        this.removeInput("ROW_DATA", true);
      }
    },

    validateControlName: function (controlName) {
      if (this.controlName != controlName) {
        let oldControlName = this.controlName;
        this.controlName = controlName;
        if (!oldControlName) {
          this.getSourceBlock().updateConnections(controlName, oldControlName);
        } else {
          setTimeout(() => {
            this.getSourceBlock().updateConnections(controlName, oldControlName);
          }, 50);
        }
      }
      return controlName;
    },

    updateConnections: function (controlName, oldControlName) {
      refreshScopeInputField(this, oldControlName, controlName, customFields);
    },
  };

  Blockly['JavaScript']['repeating-table-functionality'] = function (block) {
    let functionality = block.getFieldValue('FUNCTIONALITY');
    let controlName = block.getFieldValue('CONTROL_NAME') || '';
    let IndexValue = block.getFieldValue('INDEX_VALUE') || '';
    let showCheck = block.getFieldValue('VALUE_CHECKBOX');
    let ReadOnlyCheck = block.getFieldValue('READONLY_CHECKBOX');
    let index = Blockly['JavaScript'].valueToCode(block, 'ROW_DATA', Blockly['JavaScript'].ORDER_NONE) || 'null';
    let scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || 'null';
    let code = ` window.repeatingTableFunctionality && window.repeatingTableFunctionality('${functionality}', 'RepeatingTable####${controlName}####', ${index}, ${scopeData}, '${IndexValue}', '${showCheck}', '${ReadOnlyCheck}');\n `;
    return code;
  };

  Blockly.Blocks['api_call'] = {

    init: function () {
      this.appendStatementInput("API_CALL")
        .appendField('Launch Form - Target Setup')
        .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this), this.validateprojectNames_), "projectName")
        .appendField(new Blockly.FieldDropdown(this.generateOption.bind(this), this.validateappbuilderID_), "appbuilderID")
      this.appendDummyInput("FLAG4")
      this.appendDummyInput("BR1")
      this.appendDummyInput("FLAG1")
      this.appendDummyInput("FLAG2")
      this.appendDummyInput("FLAG10")
      this.appendDummyInput("FLAG11")
      this.appendDummyInput("BR2")
      this.appendDummyInput("FLAG5")
      this.appendDummyInput("FLAG12")
      this.appendDummyInput("FLAG13")
      this.appendDummyInput("FLAG6")
      this.appendDummyInput("BR3")
      this.appendDummyInput("FLAG3")
      this.appendDummyInput("FLAG7")
      this.appendDummyInput("FLAG8")
      this.appendDummyInput("FLAG9")
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(290);
      this.setTooltip("Get the API reponse");
      this.setHelpUrl("");
      this.jsonInit({ "mutator": "dropdown_mutator" });
    },

    generateOptions: function () {
      return projectNames
    },

    generateOption: function () {
      return appbuilderID;
    },

    validateUser_: function (selectedProjectName, block) {
      let input = block.getInput("FLAG1")
      let input2 = block.getInput("FLAG2")
      let input3 = block.getInput("FLAG3")
      let input4 = block.getInput("FLAG4")
      let input5 = block.getInput("FLAG5")
      let input6 = block.getInput("FLAG6")
      let input7 = block.getInput("FLAG7")
      let input8 = block.getInput("FLAG8")
      let input9 = block.getInput("FLAG9")
      let input10 = block.getInput("FLAG10")
      let input11 = block.getInput("FLAG11")
      let input12 = block.getInput("FLAG12")
      let input13 = block.getInput("FLAG13")
      let br1 = block.getInput("BR1");
      let br2 = block.getInput("BR1");
      let br3 = block.getInput("BR1");

      if (currentProject && (selectedProjectName == 'Current Project' || currentProject == selectedProjectName)) {

        input.removeField("cp1", true);
        input.removeField("DP_DOC_ASSOC", true);
        input2.removeField("cp2", true);
        input2.removeField("DP_ORI_FWD_DOC_ASSOC", true);
        input3.removeField("cp3", true);
        input3.removeField("DP_FORM_ASSOC", true);
        input4.removeField("cp4", true);
        input4.removeField("DP_FORM_ASSOC_CURRENT", true);
        input5.removeField("cp5", true);
        input5.removeField("DS_ATTACH_AUTOASSOCIATE_MSG", true);
        input6.removeField("cp6", true);
        input6.removeField("DP_ATTACH_ALL_MSG", true);
        input7.removeField("cp7", true);
        input7.removeField("DP_FORM_ASSOC_ORI", true);
        input8.removeField("cp8", true);
        input8.removeField("DP_All_FORM_ASSOC_CURRENT", true);
        input9.removeField("cp9", true);
        input9.removeField("DP_ALL_FORM_ASSOC", true);
        input10.removeField("cp10", true);
        input10.removeField("DP_DOC_ASSOC_CURRENT", true);
        input11.removeField("cp11", true);
        input11.removeField("DP_DOC_ASSOC_ALL_MSG", true);
        input12.removeField("cp12", true);
        input12.removeField("DP_ATTACH_ORI_MSG", true);
        input13.removeField("cp13", true);
        input13.removeField("DP_ATTACH_CURRENT_MSG", true);
        br1.removeField("BR_1", true);
        br2.removeField("BR_2", true);
        br3.removeField("BR_3", true);

        input4.appendField("Associate Source Form", 'cp4').appendField(new Blockly.FieldCheckbox(false), 'DP_FORM_ASSOC_CURRENT');
        input.appendField("Copy All Document Associations from Latest Message", 'cp1').appendField(new Blockly.FieldCheckbox(false, this.validateAllDocAssoc_), 'DP_DOC_ASSOC');
        input2.appendField("Copy All Document Associations from ORI Message", 'cp2').appendField(new Blockly.FieldCheckbox(false, this.validateAllDocAssoc_), 'DP_ORI_FWD_DOC_ASSOC');
        let label1 = new Blockly.FieldLabel('Copy All Document Associations from Current Message');
        label1.setTooltip('Copy All Document Associations from Current Message');
        input10.appendField(label1, 'cp10').appendField(new Blockly.FieldCheckbox(false, this.validateAllDocAssoc_), 'DP_DOC_ASSOC_CURRENT');
        input11.appendField("Copy All Document Associations from All Messages", 'cp11').appendField(new Blockly.FieldCheckbox(false, this.validateDocumentAssociation_), 'DP_DOC_ASSOC_ALL_MSG');
        input5.appendField("Copy All Attachments from Latest Message", 'cp5').appendField(new Blockly.FieldCheckbox(false, this.validateAllAttach_), 'DS_ATTACH_AUTOASSOCIATE_MSG');
        input12.appendField("Copy All Attachments from ORI Message", 'cp12').appendField(new Blockly.FieldCheckbox(false, this.validateAllAttach_), 'DP_ATTACH_ORI_MSG');
        input13.appendField("Copy All Attachments from Current Message", 'cp13').appendField(new Blockly.FieldCheckbox(false, this.validateAllAttach_), 'DP_ATTACH_CURRENT_MSG');
        input6.appendField("Copy All Attachments from All Messages", 'cp6').appendField(new Blockly.FieldCheckbox(false, this.validateAttachments_), 'DP_ATTACH_ALL_MSG');
        input3.appendField("Copy All Form Associations from Latest Message", 'cp3').appendField(new Blockly.FieldCheckbox(false, this.validateAllFormAssoc_), 'DP_FORM_ASSOC');
        input7.appendField("Copy All Form Associations from ORI Message", 'cp7').appendField(new Blockly.FieldCheckbox(false, this.validateAllFormAssoc_), 'DP_FORM_ASSOC_ORI');
        input8.appendField("Copy All Form Associations from Current Message", 'cp8').appendField(new Blockly.FieldCheckbox(false, this.validateAllFormAssoc_), 'DP_All_FORM_ASSOC_CURRENT');
        input9.appendField("Copy All Form Associations from All Messages", 'cp9').appendField(new Blockly.FieldCheckbox(false, this.validateFormAssociations_), 'DP_ALL_FORM_ASSOC');
        br1.appendField('', 'BR_1');
        br2.appendField('', 'BR_2');
        br3.appendField('', 'BR_3');

      } else {
        input.removeField("cp1", true);
        input.removeField("DP_DOC_ASSOC", true);
        input2.removeField("cp2", true);
        input2.removeField("DP_ORI_FWD_DOC_ASSOC", true);
        input3.removeField("cp3", true);
        input3.removeField("DP_FORM_ASSOC", true);
        input4.removeField("cp4", true);
        input4.removeField("DP_FORM_ASSOC_CURRENT", true);
        input5.removeField("cp5", true);
        input5.removeField("DS_ATTACH_AUTOASSOCIATE_MSG", true);
        input6.removeField("cp6", true);
        input6.removeField("DP_ATTACH_ALL_MSG", true);
        input7.removeField("cp7", true);
        input7.removeField("DP_FORM_ASSOC_ORI", true);
        input8.removeField("cp8", true);
        input8.removeField("DP_All_FORM_ASSOC_CURRENT", true);
        input9.removeField("cp9", true);
        input9.removeField("DP_ALL_FORM_ASSOC", true);
        input10.removeField("cp10", true);
        input10.removeField("DP_DOC_ASSOC_CURRENT", true);
        input11.removeField("cp11", true);
        input11.removeField("DP_DOC_ASSOC_ALL_MSG", true);
        input12.removeField("cp12", true);
        input12.removeField("DP_ATTACH_ORI_MSG", true);
        input13.removeField("cp13", true);
        input13.removeField("DP_ATTACH_CURRENT_MSG", true);
        br1.removeField("BR_1", true);
        br2.removeField("BR_2", true);
        br3.removeField("BR_3", true);
      }
    },

    // Function calls on select of project
    validateprojectNames_: function (projectName) {
      let appCode = [], sortingFormID = [];
      let block = this.getSourceBlock();
      this.getSourceBlock().validateUser_(projectName, block);
      this.block = projectName;
      console.log('selected project', projectName);
      if (this.projectName != projectName) {
        let oldProjectName = this.projectName;
        this.projectName = projectName;
        if (oldProjectName != undefined) {
          refreshoptionsDestinationFields_('', block);
          block.refreshoptions_(projectName);
        }
      }
      appbuilderID.splice(1, appbuilderID.length - 1);
      if (projectName != null && projectName != '' && projectName != undefined) {
        let projectid, findProject = projectsLists.filter((item) => {return item.value == projectName});
        currentProject && projectName == 'Current Project' ? projectid = currentProjectID : projectid = findProject[0] ? findProject[0].id : findProject;
        let formNameList = options.Util.getAppBuilderID(projectid)
        formNameList.then(function (filterData) {
          console.log("filterData", filterData)
          if (filterData && filterData.length > 0) {
            for (let j = 0; j < filterData.length; j++) {
              appCode.push(filterData[j].appBuilderFormIDCode);
              if (appCode[j] == "") {
                appCode[j] = `null#${+ j}`;
              }
            }
            for (let i = 0; i < filterData.length; i++) {
              sortingFormID.push([filterData[i].formTypeName, appCode[i]]);
            }
            sortingFormID = sortingFormID.sort((a, b)=>{
              if(a[0].toLowerCase() > b[0].toLowerCase()){
                return 1;
              }else{
                return -1;
              }
            });
            sortingFormID.map((array) => appbuilderID.push(array));
          }
        });
      }
      if (projectName == "") {
        appbuilderID = [['Select Form Name', '']];
        block.refreshoptions_(projectName);
        if (block.childBlocks_[0]) {
          destinationFields = [['Select Target Field', '']];
          refreshoptionsDestinationFields_('', block);
        }
      }
      return projectName;
    },

    refreshoptions_: function(projectName){
      let inputFields = this.getInput("API_CALL");
      inputFields.removeField("appbuilderID",true);
      inputFields.appendField(new Blockly.FieldDropdown(this.generateOption.bind(this), this.validateappbuilderID_), "appbuilderID");
    },

    // Function call when we select the Form name
    validateappbuilderID_: function (appbuilderCode) {
      let xpath, sortDestinationField = [];
      let block = this.getSourceBlock();
      this.block = appbuilderCode;
      let input = block.getInput('API_CALL');
      let projecTName = block.getFieldValue('projectName');
      if (this.appbuilderCode != appbuilderCode) {
        let oldAppbuilderCode = this.appbuilderCode;
        this.appbuilderCode = appbuilderCode;
        if (oldAppbuilderCode != undefined) {
          refreshoptionsDestinationFields_('', block);
        }
      }
      destinationFields.splice(0, destinationFields.length - 1);
      if (appbuilderCode) {
        appbuilderCode = appbuilderCode.split('#')[0];
        let projectid, findProject = projectsLists.filter((item) => {return item.value == projecTName});
        if (appbuilderCode == 'null') {
          options.Notification.error({ message: 'AppBuilder FormID Code is mandatory field in Form Settings, please add it for both Source and Target forms', positionX: 'center', replaceMessage: true });
          return;
        } else {
          currentProject && projecTName == 'Current Project' ? projectid = currentProjectID : projectid = findProject[0] ? findProject[0].id : findProject;
          var apiCloneBlock = this;
          let fieldNameList = options.Util.getDestinationFieldName(projectid, appbuilderCode)
          fieldNameList.then(function (responseData) {
            updateData(apiCloneBlock);
            var filterDatas = Object.keys(responseData.myFields);
            if (filterDatas && filterDatas.length > 0) {
              filterDatas = filterDatas.filter(function (elem) {
                return elem != 'extraParams' && elem != 'Asite_System_Data_Read_Write' && elem != 'Asite_System_Data_Read_Only' && elem != 'DS_AUTONUMBER_GENERATOR' && elem != 'DS_AUTONUMBER_SUFFIX';
              });
              for (let i = 0; i < filterDatas.length; i++) {
                xpath = "/my:"+Object.keys(responseData)+"/my:"+filterDatas[i];
                sortDestinationField.push([filterDatas[i], xpath]);
              }
            }
            for (var name in responseData.myFields) {
              let rtableFields: any;
              if (responseData.myFields[name] && responseData.myFields[name].value) {
                let responseDataRT = Object.keys(responseData.myFields[name].value[0]);
                for (const element of responseDataRT) {
                  rtableFields = element
                  if(Array.isArray(responseData.myFields[name].value[0][rtableFields]) == true) {
                    responseData.myFields[name].value[0][rtableFields] = '';
                  }
                  //For Repeating table inside Repeating table
                  if (responseData.myFields[name].value[0][rtableFields].value) {
                    xpath = "/my:" + Object.keys(responseData) + "/my:" + name + "/my:" + Object.keys(responseData.myFields[name])[2] + "/my:" + rtableFields + "/my:" + Object.keys(responseData.myFields[name].value[0][rtableFields])[2] + JSON.stringify(responseData.myFields[name].value[0][rtableFields].value);
                    // Now the destinationFields controls which are repeating table they having the name of the RT along with the control name. 
                    sortDestinationField.push([rtableFields +' ( '+ name +' )', xpath]);
                    let temp = Object.keys(responseData.myFields[name].value[0][rtableFields].value[0]);
                    for (const element of temp) {
                      let tempf = element;
                      if(Array.isArray(responseData.myFields[name].value[0][rtableFields]) == true) {
                        responseData.myFields[name].value[0][rtableFields] = '';
                      }
                      xpath = "/my:" + Object.keys(responseData) + "/my:" + name + "/my:" + Object.keys(responseData.myFields[name])[2] + "/my:" + rtableFields + "/my:" + Object.keys(responseData.myFields[name].value[0][rtableFields])[2] + "/my:" + tempf;
                      sortDestinationField.push([tempf +' ( '+ rtableFields +' )', xpath]);
                    }
                  } else {
                    xpath = "/my:" + Object.keys(responseData) + "/my:" + name + "/my:" + Object.keys(responseData.myFields[name])[2] + "/my:" + rtableFields;
                    sortDestinationField.push([rtableFields +' ( '+ name +' )', xpath]);
                  }
                }

              }
              if (responseData.myFields[name] && responseData.myFields[name].value) {
                for (let j = 0; j < sortDestinationField.length; j++) {
                  if (name == sortDestinationField[j][0]) {
                    sortDestinationField[j] = [name,  "/my:"+Object.keys(responseData)+"/my:"+name+"/my:"+Object.keys(responseData.myFields[name])[2]+JSON.stringify(responseData.myFields[name].value)];
                  }
                }
              }
            }
            sortDestinationField.sort((a, b) => {
              if (a[0].toLowerCase() > b[0].toLowerCase()) {
                return 1;
              } else {
                return -1;
              }
            });
            sortDestinationField.map((array) => destinationFields.push(array));
            updateData(apiCloneBlock);
          });
        }
      }
      if (appbuilderCode == "" && block.childBlocks_[0]) {
        destinationFields = [['Select Target Field', '']];
        refreshoptionsDestinationFields_(appbuilderCode, block);
      }
      return appbuilderCode;
    }, 
    
    validateDocumentAssociation_: function (flagName) {
      let block = this.getSourceBlock();
      if (flagName && flagName == "TRUE") {
        block.setFieldValue(false, 'DP_DOC_ASSOC');
        block.setFieldValue(false, 'DP_ORI_FWD_DOC_ASSOC');
        block.setFieldValue(false, 'DP_DOC_ASSOC_CURRENT');
      }
    },
    validateAttachments_: function (flagName) {
      let block = this.getSourceBlock();
      if (flagName && flagName == "TRUE") {
        block.setFieldValue(false, 'DS_ATTACH_AUTOASSOCIATE_MSG');
        block.setFieldValue(false, 'DP_ATTACH_ORI_MSG');
        block.setFieldValue(false, 'DP_ATTACH_CURRENT_MSG');
      }
    },
    validateFormAssociations_: function (flagName) {
      let block = this.getSourceBlock();
      if (flagName && flagName == "TRUE") {
        block.setFieldValue(false, 'DP_FORM_ASSOC');
        block.setFieldValue(false, 'DP_FORM_ASSOC_ORI');
        block.setFieldValue(false, 'DP_All_FORM_ASSOC_CURRENT');
      }
    },
    validateAllDocAssoc_: function (flagName) {
      let block = this.getSourceBlock();
      if (flagName && flagName == "TRUE") {
          block.setFieldValue(false, 'DP_DOC_ASSOC_ALL_MSG');
      }
    },
    validateAllAttach_: function (flagName) {
      let block = this.getSourceBlock();
      if (flagName && flagName == "TRUE") {
          block.setFieldValue(false, 'DP_ATTACH_ALL_MSG');
      }
    },
    validateAllFormAssoc_: function (flagName) {
      let block = this.getSourceBlock();
      if (flagName && flagName == "TRUE") {
          block.setFieldValue(false, 'DP_ALL_FORM_ASSOC');
      }
    }
  }

  function updateData(block) {
    try {
      let childBlock;
      if (block.sourceBlock_) {
        childBlock = block.sourceBlock_.childBlocks_[0];
      } else
        childBlock = block.childBlocks_[0];

      if (!childBlock) {
        return;
      }
      let inputFields = childBlock.getField('destinationName');
      if (inputFields) {
        if (inputFields.selectedOption_[1].indexOf("/my:myFields") == -1) {
          if (inputFields.selectedOption_[1].startsWith('[') && inputFields.selectedOption_[1].endsWith(']')) {
            inputFields.selectedOption_[1] = "/my:myFields/my:" + inputFields.selectedOption_[0] + "/my:value" + inputFields.selectedOption_[1];
            inputFields.value_ = inputFields.selectedOption_[1];
          } else {
            inputFields.selectedOption_[1] = "/my:myFields/my:" + inputFields.selectedOption_[1];
            inputFields.value_ = inputFields.selectedOption_[1];
          }
        }

        if (destinationFields.length > 1) {
          let field, index = destinationFields.findIndex(array => inputFields.selectedOption_[0] === array[0]);
          field = destinationFields[index];
          if (field && inputFields.value_ != field[1]) {
            inputFields.selectedOption_[1] = field[1];
            inputFields.value_ = field[1];
          }
        }
      }
      updateData(childBlock);
    } catch (e) {
      console.log("updateData", e);
    }
  }

  function refreshoptionsDestinationFields_(appbuilderCode, block) {
    let childBlock = block.childBlocks_[0];
    if (!childBlock) {
      return;
    }
    let inputFields = childBlock.getInput('API_DATA_CLONE');
    inputFields.removeField("sourceCntName", true);
    inputFields.removeField("destinationName", true);
    inputFields.appendField(new Blockly.FieldDropdown(sourceFields), "sourceCntName")
      .appendField(new Blockly.FieldDropdown(childBlock.generateOptions.bind(childBlock)), "destinationName");
    refreshoptionsDestinationFields_(appbuilderCode, childBlock);
  }

  Blockly['JavaScript']['api_call'] = function (block) {
    let projectName = block.getFieldValue('projectName');
    let appbuilderID = block.getFieldValue('appbuilderID');
    let dp_DOC_ASSOC = block.getFieldValue('DP_DOC_ASSOC');
    let dp_ORI_FWD_DOC_ASSOC = block.getFieldValue('DP_ORI_FWD_DOC_ASSOC')
    let dp_FORM_ASSOC = block.getFieldValue('DP_FORM_ASSOC')
    let dp_FORM_ASSOC_CURRENT = block.getFieldValue('DP_FORM_ASSOC_CURRENT')
    let ds_ATTACH_AUTOASSOCIATE_MSG = block.getFieldValue('DS_ATTACH_AUTOASSOCIATE_MSG')
    let dp_ATTACH_ALL_MSG = block.getFieldValue('DP_ATTACH_ALL_MSG')
    let dp_FORM_ASSOC_ORI = block.getFieldValue("DP_FORM_ASSOC_ORI")
    let dp_All_FORM_ASSOC_CURRENT = block.getFieldValue("DP_All_FORM_ASSOC_CURRENT")
    let dp_ALL_FORM_ASSOC = block.getFieldValue("DP_ALL_FORM_ASSOC")
    let dp_DOC_ASSOC_CURRENT = block.getFieldValue("DP_DOC_ASSOC_CURRENT")
    let dp_DOC_ASSOC_ALL_MSG = block.getFieldValue("DP_DOC_ASSOC_ALL_MSG")
    let dp_ATTACH_ORI_MSG = block.getFieldValue("DP_ATTACH_ORI_MSG")
    let dp_ATTACH_CURRENT_MSG = block.getFieldValue("DP_ATTACH_CURRENT_MSG")
    let apiHandler = Blockly['JavaScript'].statementToCode(block, 'API_CALL');

    let code = `window.getFormViewDetail('${projectName}','${appbuilderID}','${dp_DOC_ASSOC}','${dp_ORI_FWD_DOC_ASSOC}','${dp_FORM_ASSOC}','${dp_FORM_ASSOC_CURRENT}','${ds_ATTACH_AUTOASSOCIATE_MSG}','${dp_ATTACH_ALL_MSG}',
    function() {
      var temp = [];
      ${apiHandler}
      return temp;
      },
      '${dp_FORM_ASSOC_ORI}', '${dp_All_FORM_ASSOC_CURRENT}', '${dp_ALL_FORM_ASSOC}', '${dp_DOC_ASSOC_CURRENT}', '${dp_DOC_ASSOC_ALL_MSG}', '${dp_ATTACH_ORI_MSG}', '${dp_ATTACH_CURRENT_MSG}'
      );\n`

    return code;
  };

  Blockly.Blocks['api_data_clone'] = {

    init: function () {
      this.appendDummyInput("API_DATA_CLONE")
        .appendField('Launch Form Field Mapping')
        .appendField(new Blockly.FieldDropdown(sourceFields), "sourceCntName")
        .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this)), "destinationName");
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(290);
      this.setTooltip("data swipe");
      this.setHelpUrl("");
      this.jsonInit({ "mutator": "dropdown_mutator" });
    },
    generateOptions: function () {
      return destinationFields;
    }
  }

  Blockly['JavaScript']['api_data_clone'] = function (block) {
    let scr_Name = block.getFieldValue('sourceCntName');
    let des_Name = block.getFieldValue('destinationName');

    console.log(scr_Name, des_Name);
    let code = ` temp.push({source : '${scr_Name}', destination : '${des_Name}'})\n `;
    return code;
  };

  /** New Colour picker Block with enhancement to support 0 to 255 numbers*/
  
  Blockly.Blocks['new_colour_rgb'] = {
    init: function () {
      this.appendValueInput("RED")
          .setAlign(Blockly.ALIGN_RIGHT)
          .appendField("colour with red");
      this.appendValueInput("GREEN")
          .setAlign(Blockly.ALIGN_RIGHT)
          .appendField("green");
      this.appendValueInput("BLUE")
          .setAlign(Blockly.ALIGN_RIGHT)
          .appendField("blue");
      this.setInputsInline(false);
      this.setOutput(true, Array);
      this.setColour(20);
      this.setTooltip("Create a colour with the specified amount of red, green and blue. All the values must be between 0 and 255");
      this.setHelpUrl("");
    },   
  }
  Blockly['JavaScript']['new_colour_rgb'] = function(block) {
    // Compose a colour from RGB components expressed as percentages.
    var red = Blockly['JavaScript'].valueToCode(block, 'RED',
        Blockly['JavaScript'].ORDER_COMMA) || 0;
    var green = Blockly['JavaScript'].valueToCode(block, 'GREEN',
        Blockly['JavaScript'].ORDER_COMMA) || 0;
    var blue = Blockly['JavaScript'].valueToCode(block, 'BLUE',
        Blockly['JavaScript'].ORDER_COMMA) || 0;
    var functionName = Blockly['JavaScript'].provideFunction_(
        'new_colourRgb',
        ['function ' + Blockly['JavaScript'].FUNCTION_NAME_PLACEHOLDER_ +
            '(r, g, b) {',
         '  r = Math.max(Math.min(Number(r), 255), 0);',
         '  g = Math.max(Math.min(Number(g), 255), 0);',
         '  b = Math.max(Math.min(Number(b), 255), 0);',
         '  r = (\'0\' + (Math.round(r) || 0).toString(16)).slice(-2);',
         '  g = (\'0\' + (Math.round(g) || 0).toString(16)).slice(-2);',
         '  b = (\'0\' + (Math.round(b) || 0).toString(16)).slice(-2);',
         '  return \'#\' + r + g + b;',
         '}']);
    var code = functionName + '(' + red + ', ' + green + ', ' + blue + ')';
    return [code, Blockly['JavaScript'].ORDER_FUNCTION_CALL];
  };

  Blockly.Blocks['get-new-custom-response'] = {
    init: function () {
      this.appendValueInput('NEW_RESPONSE_DATA').setCheck(null).appendField("  API Data", "NEW_API_DATA_KEY")
      this.appendDummyInput("New_CUSTOM_RESPONSE")
        .appendField("Select field ")
        .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this), this.validateFieldOptions), "NEW_FIELD_NAME")
        .appendField(" Value", 'SET_VALUE')
        .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this)), 'VALUE_NAME')
        .appendField(" Display Name", 'SET_KEY_NAME')
        .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this)), 'NAME_MAP')
      this.setInputsInline(true);
      this.setOutput(true);
      this.setColour(290);
      this.setTooltip("Fetch field data from API response");
      this.setHelpUrl("");
      this.jsonInit({ "mutator": "dropdown_mutator" });
    },
    generateOptions: function () {
      let responseDataOptionsNew = [['Please select', 'Please select']];
      let block = this;
      if (block && block.childBlocks_ && block.childBlocks_[0] && block.childBlocks_[0].getVarModels()[0] && block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']) {
        let options = block.recursionOnResponseData(responseDataOptionsNew, block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']);
        return options;
      } else {
        if (block && block.type == 'get-new-custom-response' && block.parentBlock_) {
          var apiBLock = block.findAPIBlock(block.parentBlock_);
          if (apiBLock && apiBLock.responseDataFromAPI) {
            let options = block.recursionOnResponseData(responseDataOptionsNew, apiBLock.responseDataFromAPI);
            return options;
          }
        }
      }
      return responseDataOptionsNew;
    },
    findAPIBlock: function (block) {
      if (block && block.type == 'set_api_data') {
        return block;
      } else {
        if (block)
          return this.findAPIBlock(block.parentBlock_);
      }
    },
    recursionOnResponseData: function (arr, responseData, parentkey, parentArrPathKey) {
      if (responseData.length > 0) {
        responseData = responseData[0];
      }
      for (var key in responseData) {
        if (responseData.hasOwnProperty(key)) {
          var elemVal = responseData[key];
          if ((elemVal == null) || (typeof (elemVal) != 'object')) {
            if (parentkey) {
              arr.push([parentkey + '.' + key, parentkey + '.' + key])
            } else if (parentArrPathKey) {
              let keyPath = parentArrPathKey + '["' + key + '"]';
              arr.push([keyPath, key]);
            } else {
              arr.push([key, key]);
            }
          } else if (elemVal != null && typeof (elemVal) == 'object' && elemVal.length > 0) {
            let parentkeynew = parentkey ? parentkey + '.' + key : key;
            arr.push([parentkeynew, parentkeynew]);
            this.recursionOnResponseData(arr, elemVal[0], '', parentkeynew);
          } else {
            let parentkeynew = parentkey ? parentkey + '.' + key : key;
            this.recursionOnResponseData(arr, elemVal, parentkeynew);
          }
        }
      }
      return arr;
    },
    validateFieldOptions: function (fieldName) {
      let block = this.getSourceBlock();
      if (this.fieldName != fieldName) {
        let oldfieldName = this.fieldName;
        this.fieldName = fieldName;
        if (!oldfieldName) {
          this.getSourceBlock().onFieldNameChanged(block);
        } else {
          setTimeout(() => {
            this.getSourceBlock().onFieldNameChanged(block);
          }, 500);
        }
      }
      return fieldName;
    },
    onFieldNameChanged: function (block) {
      refreshDropdownNewInputField(block);
    },
  }
  Blockly['JavaScript']['get-new-custom-response'] = function (block) {
    let ct_name = block.getFieldValue('NEW_FIELD_NAME');
    let optionMap = block.getFieldValue('VALUE_NAME');
    let optionMapName = block.getFieldValue('NAME_MAP');
    let responseData = Blockly['JavaScript'].valueToCode(block, 'NEW_RESPONSE_DATA', Blockly['JavaScript'].ORDER_NONE) || 'null';
    let code = `window.getCustomResponse && window.getCustomResponse('${ct_name}',${responseData}, '${optionMap}' , '${optionMapName}')\n `;
    return [code, Blockly['JavaScript'].ORDER_NONE];
  };

  Blockly.Blocks['custom-set-alert-msg'] = {
    init: function () {
      this.appendDummyInput('CUSTOM_PROP_SETTER_DUMMY_INPUT')
      .appendField("Set Alert Message : ")
      this.appendValueInput('MSG_VALUE_INPUT').setCheck(null);
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(Blockly.Msg.PROCEDURES_HUE);
      this.setTooltip("Set msg");
      this.setHelpUrl("");
    },
  }
  Blockly['JavaScript']['custom-set-alert-msg'] = function (block) {
    let msgText = Blockly['JavaScript'].valueToCode(block, 'MSG_VALUE_INPUT', Blockly['JavaScript'].ORDER_NONE) || '';
    let code = `window.setAlertMsg && window.setAlertMsg(${msgText})\n `;
    return code;
  };
  Blockly.Blocks['check_for_external_associations'] = {
    init: function () {
      this.appendStatementInput("EXTERNAL_ASSOCIATIONS")
        .appendField("Check for Associations ");
      this.setInputsInline(true);
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(230);
      this.setTooltip("Use this function block to check for external associations");
      this.setHelpUrl("");
    },
  };

  Blockly['JavaScript']['check_for_external_associations'] = function (block) {
    let logicHandler = Blockly['JavaScript'].statementToCode(block, 'EXTERNAL_ASSOCIATIONS');
    let code = `function checkForExternalAssociations(){
      ${logicHandler}
    };\n`
    return code;
  };
  Blockly.Blocks['check_for_association_external_by_view'] = {

    init: function () {
      this.appendDummyInput("CHECK_FOR_VIEW_ASSOC")
        .appendField('Select view')
        .appendField(new Blockly.FieldDropdown(ViewNamesList), "VIEW_NAME")
        .appendField('Select Type')
        .appendField(new Blockly.FieldDropdown([['Please select', 'Please select'],['Files','Files'],['Apps','Apps']]), "ASSOC_TYPE")
      this.setInputsInline(true);
      this.setOutput(true);
      this.setColour(290);
      this.setTooltip("check_for_association_external_by_view");
      this.setHelpUrl("");
    },
  }

  Blockly['JavaScript']['check_for_association_external_by_view'] = function (block) {
    let viewName = block.getFieldValue('VIEW_NAME');
    let assocType = block.getFieldValue('ASSOC_TYPE');
    let code = `window.setAndVerifyDocAssocForView && window.setAndVerifyDocAssocForView("${viewName}","${assocType}")\n `;
    return [code, Blockly['JavaScript'].ORDER_VOID];
  };
  

}


// WEBPACK FOOTER //
// ./client/components/blockly/blockly.custom.block.ts